'use client'

import { useEffect } from 'react'

const Arrow = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
)
const Check = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="20 6 9 17 4 12"/></svg>
)
const PlusIcon = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden><path d="M12 5v14"/><path d="M5 12h14"/></svg>
)

const ATIVOS = [
  { nome: 'Mentoria', preco: 'R$ 2.000', prazo: '2-3 sem', desc: 'Sistematização do atendimento. Framework de sessão, roteiro diagnóstico, formulário, emails, precificação.', icon: 'menu' },
  { nome: 'Curso até 25 aulas', preco: 'R$ 3.500', prazo: '4-6 sem', desc: 'Arquitetura pedagógica, roteiros, orientação de gravação, página de vendas. Expert grava sozinho.', icon: 'play' },
  { nome: 'Curso até 60 aulas', preco: 'R$ 5.500', prazo: '6-8 sem', desc: 'Tudo do anterior, mais material complementar (PDFs, exercícios, templates por aula).', icon: 'play' },
  { nome: 'Livro até 150 págs', preco: 'R$ 5.500', prazo: '10-14 sem', desc: 'Co-escrita: expert escreve rascunho, eBuz refina. Revisão, diagramação, capa e publicação KDP.', icon: 'book' },
  { nome: 'Livro até 350 págs', preco: 'R$ 10.900', prazo: '16-20 sem', desc: 'Ghostwriting: eBuz escreve a partir de entrevistas. Inclui EPUB e audiobook TTS.', icon: 'book' },
  { nome: 'Comunidade Telegram', preco: 'R$ 1.500', prazo: '1-2 sem', desc: 'Setup do grupo, automação de entrada, manual de operações e curso incluso.', icon: 'send' },
  { nome: 'Palestra', preco: 'R$ 1.200', prazo: '2 sem', desc: 'Roteiro completo 45-90min com arco narrativo e slides profissionais.', icon: 'mic' },
  { nome: 'Palestra Premium', preco: 'R$ 1.900', prazo: '3 sem', desc: 'Tudo da Palestra, mais ensaio orientado por Meet com feedback.', icon: 'star' },
] as const

const ASSET_ICONS: Record<string, JSX.Element> = {
  menu: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M17 6.1H3"/><path d="M21 12.1H3"/><path d="M15.1 18H3"/></svg>,
  play: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/></svg>,
  book: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></svg>,
  bar: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><line x1="4" x2="4" y1="21" y2="14"/><line x1="4" x2="4" y1="10" y2="3"/><line x1="12" x2="12" y1="21" y2="12"/><line x1="12" x2="12" y1="8" y2="3"/><line x1="20" x2="20" y1="21" y2="16"/><line x1="20" x2="20" y1="12" y2="3"/><line x1="2" x2="6" y1="14" y2="14"/><line x1="10" x2="14" y1="8" y2="8"/><line x1="18" x2="22" y1="16" y2="16"/></svg>,
  send: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="m21.854 2.147-10.94 10.939"/><path d="m21.854 2.147-6.617 19.198a.5.5 0 0 1-.937-.024l-2.62-7.972a1 1 0 0 0-.635-.635L2.673 9.894a.5.5 0 0 1-.024-.937z"/></svg>,
  mic: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M3 11h18"/><path d="M12 19l8-8H4l8 8z"/><path d="M12 4v6"/></svg>,
  star: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/></svg>,
  monitor: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><rect width="20" height="14" x="2" y="3" rx="2"/><line x1="8" x2="16" y1="21" y2="21"/><line x1="12" x2="12" y1="17" y2="21"/></svg>,
}

const ISCAS_CONV = [
  { nome: 'Call Diagnóstico', slug: 'call-diagnostico', preco: 'R$ 1.500', desc: 'Roteiro 4 blocos, formulário, emails e follow-up' },
  { nome: 'Webinar', slug: 'webinar', preco: 'R$ 2.500', desc: 'Roteiro, slides, páginas, emails e replay' },
  { nome: 'CPL/Lançamento', slug: 'cpl-lancamento', preco: 'R$ 10.000', desc: '3-4 episódios, emails, página de vendas e urgência' },
  { nome: 'VSL/Perpétuo', slug: 'vsl-perpetuo', preco: 'R$ 5.000', desc: 'Roteiro 6 blocos, orientação de gravação e página' },
  { nome: 'Tripwire', slug: 'tripwire', preco: 'R$ 1.800', desc: 'Produto entrada, templates e sequência upsell' },
  { nome: 'Anúncio de Vaga', slug: 'anuncio-de-vaga', preco: 'R$ 400', desc: 'Script stories, WhatsApp, timing e checklist' },
]
const ISCAS_QUAL = [
  { nome: 'Quiz/Diagnóstico', slug: 'quiz-diagnostico', preco: 'R$ 1.200', desc: 'Estágios, perguntas, resultados e automação' },
  { nome: 'Email/Nutrição', slug: 'email-nutricao', preco: 'R$ 1.500', desc: 'Sequências por entrada, emails e automação' },
  { nome: 'Desafio 5-7 dias', slug: 'desafio-5-7-dias', preco: 'R$ 1.800', desc: 'Estrutura, tarefa por dia, suporte, grupo e oferta' },
  { nome: 'Demo ao Vivo', slug: 'demo-ao-vivo', preco: 'R$ 1.200', desc: 'Roteiro, produção, convite segmentado e follow-up' },
  { nome: 'Série/Mini-curso', slug: 'serie-mini-curso', preco: 'R$ 2.000', desc: 'Arco, roteiro de episódios, emails e oferta final' },
  { nome: 'Pesquisa Co-criação', slug: 'pesquisa-co-criacao', preco: 'R$ 800', desc: 'Formulário, análise, devolutiva e publicação' },
]
const ISCAS_POS = [
  { nome: 'Bastidores', slug: 'bastidores', preco: 'R$ 500', desc: 'Roteiro de processo real, narrativa, resultado e CTA' },
  { nome: 'Opinião Forte', slug: 'opiniao-forte', preco: 'R$ 350', desc: 'Post na voz, sustentação e objeção antecipada' },
  { nome: 'Dado de Impacto', slug: 'dado-de-impacto', preco: 'R$ 1.500', desc: 'Pesquisa ampla, validação, carrossel e implicação' },
  { nome: 'Story/Manifesto', slug: 'story-manifesto', preco: 'R$ 300', desc: 'Script na voz, design 3-4 stories e CTA' },
  { nome: 'Meme/Analogia', slug: 'meme-analogia', preco: 'R$ 250', desc: 'Analogia original, design e ancoragem da marca' },
  { nome: 'Live/Q&A', slug: 'live-qa', preco: 'R$ 600', desc: 'Roteiro 3 blocos, moderação e email pós-live' },
]

const FAQS = [
  { q: 'Como vou saber se isso vai dar certo pra mim? Já paguei agência três vezes.', a: 'Você não vai saber antes de fazer o Mapa de Contexto. Mas vai saber depois — não porque vou prometer venda, e sim porque o Mapa entrega vocabulário pra você reconhecer o que estava errado nas três agências anteriores. Se o vocabulário não bater com o seu caso, você sai. Se bater, marca Reunião de Confronto. Em qualquer caminho: zero investimento até aqui.' },
  { q: '10% perpétuo significa pagar pra sempre. E se eu quiser sair?', a: 'Você só paga enquanto vende. Cliente que para de vender, para de pagar — sem cobrança mínima, sem multa, sem retorno forçado. Se quiser sair completamente do Whitelabel, leva seus dados, audiência, conteúdo, lista e histórico de vendas. A engenharia fica. Não há fidelidade contratual em nenhum tier.' },
  { q: 'Tenho 200 alunos em outra plataforma. Migrar não vai dar um trabalho enorme?', a: 'A migração é parte do escopo do Pacote DFY. Meu time faz: importação da lista, transferência dos conteúdos, reemissão de acessos, redirecionamentos, comunicação técnica com a plataforma anterior. Você toca em uma única coisa: a mensagem que vai pros seus alunos antes do go-live anunciando a mudança. Texto padrão é entregue pelo time, você só personaliza.' },
  { q: 'R$ 4.500 + 10% — e se eu não vender? Que garantia eu tenho?', a: 'A garantia é o oposto da do mercado: se você não vender, eu também não ganho. Alinhamento de incentivo absoluto. Os R$ 4.500 da Ignição cobrem o serviço de construção — Mapa do Ecossistema, Sessão do Tácito, Dossiê do Expert, 2 ativos, 3 iscas, 1 funil, Whitelabel completo. Se isso for entregue e a operação subir, o serviço foi prestado. Daí em diante, eu só ganho 10% se você ganhar 100%.' },
  { q: 'Como sei se tenho Tese Vivida pra começar? E se a Reunião mostrar que não tenho?', a: 'A Reunião de Confronto existe pra responder isso, não pra te punir por não ter resposta. O Aperto Triplo é desenhado pra extrair a Tese que está dentro de você e que você ainda não consegue articular sozinho. Se ficar claro que você ainda não tem matéria-prima pra entrar no Pacote DFY agora, eu te digo na cara, sem cobrar. Você sai com o Mapa de Contexto na mão e volta quando o caso amadurecer. A Reunião é gratuita, e a honestidade nela também.' },
  { q: 'Vocês trabalham com qualquer nicho?', a: 'Não. Tem filtro: aceito ofício, recuso fantasia. Ofício é o que transfere competência real — depois de consumir o produto, o aluno sai capaz de fazer algo que antes não fazia, e esse algo é verdadeiro. Fantasia é o que vende transformação sem método verificável: MLM, prosperity esotérica, trading com retorno garantido, cura sem evidência clínica, motivacional vazio, terraplanismo high-ticket. Não trabalho com fantasia. Não é preconceito de nicho — é coerência epistêmica.' },
  { q: 'Vocês fazem gestão de tráfego pago?', a: 'Não. Construo a infra que recebe tráfego (páginas, automação, funis, métricas) mas não gerencio Meta Ads ou Google Ads. Indicamos parceiros de confiança quando faz sentido.' },
]

const CALC_ATIVOS = [
  { name: 'Site/Identidade', price: 2500 },
  { name: 'Plataforma de Cursos', price: 4500 },
  { name: 'Sistema (App)', price: 14900 },
  { name: 'Livro 150p', price: 5500 },
  { name: 'Livro 350p', price: 10900 },
  { name: 'Blog Setup', price: 2000 },
  { name: 'Comunidade Telegram', price: 1500 },
  { name: 'Palestra', price: 1200 },
]
const CALC_ISCAS = [
  { name: 'Call Diagnóstico', price: 1500 },
  { name: 'Webinar', price: 2500 },
  { name: 'CPL/Lançamento', price: 10000 },
  { name: 'Quiz', price: 800 },
  { name: 'eBook', price: 600 },
  { name: 'Newsletter', price: 900 },
  { name: 'Mini-curso', price: 1800 },
  { name: 'Checklist', price: 400 },
]
const CALC_FUNIS = [
  { name: 'Funil Simples', price: 1200 },
  { name: 'Funil Complexo', price: 3500 },
  { name: 'Funil de Lançamento', price: 5000 },
]

export default function TabelaClient() {
  useEffect(() => {
    // 1) Scroll progress bar
    const sp = document.getElementById('scrollProgress')
    const onScroll = () => {
      const h = document.documentElement
      const pct = (h.scrollTop || document.body.scrollTop) / (h.scrollHeight - h.clientHeight) * 100
      if (sp) sp.style.width = Math.max(0, Math.min(100, pct)) + '%'
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()

    // 2) Hero mesh follows cursor
    const hero = document.getElementById('hero')
    const mesh = document.getElementById('heroMesh')
    const onMove = (e: MouseEvent) => {
      if (!hero || !mesh) return
      const r = hero.getBoundingClientRect()
      mesh.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%')
      mesh.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%')
    }
    if (hero) hero.addEventListener('mousemove', onMove)

    // 3) Marquee duplicate (seamless loop)
    const mt = document.getElementById('marqTrack')
    if (mt && !mt.dataset.dup) {
      mt.innerHTML += mt.innerHTML
      mt.dataset.dup = '1'
    }

    // 4) IntersectionObserver pra .reveal
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in')
          io.unobserve(e.target)
        }
      })
    }, { threshold: 0.12 })

    const selectors = ['.section-head', '.dcard', '.pack', '.asset', '.isca', '.funil', '.op-card', '.community', '.rules', '.calc', '.faq-item', '.matrix', '.hero-stat', '.article-pack', '.dark-cta']
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el, i) => {
        el.classList.add('reveal')
        if (i % 4 === 1) el.classList.add('reveal-delay-1')
        if (i % 4 === 2) el.classList.add('reveal-delay-2')
        if (i % 4 === 3) el.classList.add('reveal-delay-3')
        io.observe(el)
      })
    })

    // 5) Smooth scroll for nav anchors
    const onAnchorClick = (e: Event) => {
      const a = e.currentTarget as HTMLAnchorElement
      const id = a.getAttribute('href') || ''
      if (id.length > 1 && id.startsWith('#')) {
        const t = document.querySelector(id)
        if (t) {
          e.preventDefault()
          window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' })
        }
      }
    }
    document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((a) => {
      a.addEventListener('click', onAnchorClick)
    })

    return () => {
      window.removeEventListener('scroll', onScroll)
      if (hero) hero.removeEventListener('mousemove', onMove)
      io.disconnect()
      document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((a) => {
        a.removeEventListener('click', onAnchorClick)
      })
    }
  }, [])

  // ─── State for matrix toggle ─────────────────────────────────────
  const matrixToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    const btn = e.currentTarget
    const mx = document.getElementById('matrix')
    if (!mx) return
    const open = !mx.hasAttribute('hidden')
    const span = btn.querySelector('span')
    if (open) {
      mx.setAttribute('hidden', '')
      mx.classList.remove('in')
      if (span) span.textContent = 'Ver matriz comparativa completa'
    } else {
      mx.removeAttribute('hidden')
      if (span) span.textContent = 'Ocultar matriz comparativa'
      setTimeout(() => mx.classList.add('in'), 10)
    }
  }

  // ─── FAQ accordion (click handler) ────────────────────────────────
  const faqClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const q = e.currentTarget
    const item = q.parentElement as HTMLElement | null
    if (!item) return
    const open = item.classList.contains('open')
    document.querySelectorAll('.faq-item.open').forEach((o) => o.classList.remove('open'))
    if (!open) item.classList.add('open')
  }

  // ─── Calculadora (click handler) ─────────────────────────────────
  const calcToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.classList.toggle('on')
    updateCalcSummary()
  }

  const updateCalcSummary = () => {
    const summary = document.getElementById('calcSummary')
    const totalEl = document.getElementById('calcTotal')
    if (!summary || !totalEl) return
    const fmt = (n: number) => 'R$ ' + n.toLocaleString('pt-BR')
    const picks = document.querySelectorAll<HTMLButtonElement>('.calc-opt.on')
    const byGroup: Record<string, Array<{ name: string; price: number }>> = { ativos: [], iscas: [], funis: [] }
    let total = 0
    picks.forEach((p) => {
      const g = p.parentElement?.getAttribute('data-group') || ''
      const price = parseInt(p.getAttribute('data-price') || '0', 10)
      total += price
      if (byGroup[g]) byGroup[g].push({ name: p.getAttribute('data-name') || '', price })
    })
    if (!picks.length) {
      summary.innerHTML = '<p class="calc-empty">Comece selecionando os ativos que você precisa →</p>'
    } else {
      let html = ''
      const labels: Record<string, string> = { ativos: 'Ativos', iscas: 'Iscas', funis: 'Funis' }
      ;(['ativos', 'iscas', 'funis'] as const).forEach((g) => {
        if (byGroup[g].length) {
          const sub = byGroup[g].reduce((a, b) => a + b.price, 0)
          html += '<div class="calc-summary-row"><span>' + labels[g] + ' (' + byGroup[g].length + ')</span><b>' + fmt(sub) + '</b></div>'
          byGroup[g].forEach((it) => {
            html += '<div class="calc-summary-row" style="font-size:11.5px;color:rgba(255,255,255,.5);padding:2px 0 2px 12px;border:0"><span>· ' + it.name + '</span><span>' + fmt(it.price) + '</span></div>'
          })
        }
      })
      summary.innerHTML = html
    }
    totalEl.textContent = fmt(total)
  }

  return (
    <div className="tabela-root">
      <style dangerouslySetInnerHTML={{ __html: TABELA_CSS }} />

      {/* Scroll progress bar */}
      <div className="scroll-progress" id="scrollProgress" />

      {/* TOP NAV */}
      <nav className="topnav">
        <div className="topnav-inner">
          <a className="brand" href="/">
            <span className="brand-mark" />
            <span className="brand-text">ebuz<small>negócios digitais</small></span>
          </a>
          <div className="topnav-links">
            <a href="#jornada">Jornada</a>
            <a href="#dossie">Dossiê</a>
            <a href="#pacotes">Pacotes</a>
            <a href="#iscas">Iscas</a>
            <a href="#funis">Funis</a>
            <a href="#faq">FAQ</a>
          </div>
          <a className="t-btn t-btn-dark t-btn-sm" href="https://ebuz.com.br/passo1">
            Começar agora <Arrow />
          </a>
        </div>
      </nav>

      {/* HERO */}
      <header className="hero" id="hero">
        <div className="hero-mesh" id="heroMesh" />
        <div className="hero-glyphs" aria-hidden>
          <span className="gly" style={{ top: '18%', left: '8%', animationDelay: '0s' }}>{'// expert'}</span>
          <span className="gly lg" style={{ top: '62%', left: '6%', animationDelay: '-2s' }}>{'{ ecossistema }'}</span>
          <span className="gly" style={{ top: '78%', left: '14%', animationDelay: '-4s' }}>→ funil</span>
          <span className="gly xl" style={{ top: '24%', right: '6%', animationDelay: '-6s' }}>/dossiê</span>
          <span className="gly" style={{ top: '70%', right: '9%', animationDelay: '-8s' }}>.tácito_</span>
          <span className="gly" style={{ top: '46%', right: '18%', animationDelay: '-1s' }}>posicionamento</span>
          <span className="gly-plus" style={{ top: '12%', left: '22%', animationDelay: '-3s' }} />
          <span className="gly-plus white" style={{ top: '30%', left: '36%', animationDelay: '-5s' }} />
          <span className="gly-plus" style={{ top: '80%', left: '30%', animationDelay: '-7s' }} />
          <span className="gly-plus white" style={{ top: '18%', right: '28%', animationDelay: '-2s' }} />
          <span className="gly-plus" style={{ top: '62%', right: '32%', animationDelay: '-9s' }} />
          <span className="gly-plus white" style={{ top: '88%', right: '14%', animationDelay: '-4s' }} />
        </div>
        <div className="t-shell">
          <div className="hero-inner">
            <div className="kicker"><span className="plus" /> ebuz negócios digitais <span className="plus" /></div>
            <h1>Pare de publicar a <span className="t-grad-text">versão diluída</span> de você.</h1>
            <p className="hero-lede">Whitelabel próprio. 10% por êxito. Sem mensalidade. A versão de você que entra no mercado finalmente cobre a que opera no consultório, no palco e no atendimento privado.</p>
            <div className="hero-pills">
              <span className="pill pill-mono pill-light">Whitelabel próprio</span>
              <span className="pill pill-mono pill-light">10% por êxito · só paga se vender</span>
              <span className="pill pill-mono pill-light">Sem mensalidade</span>
              <span className="pill pill-mono pill-light">Aceito ofício, recuso fantasia</span>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="num"><span className="t-grad-text">5</span></span>
                <span className="lbl">Etapas da jornada</span>
              </div>
              <div className="hero-stat">
                <span className="num">3</span>
                <span className="lbl">Pacotes de implantação</span>
              </div>
              <div className="hero-stat">
                <span className="num">18+</span>
                <span className="lbl">Iscas catalogadas</span>
              </div>
              <div className="hero-stat">
                <span className="num"><span className="live-dot" /><span style={{ fontFamily: 'var(--tmono)', fontSize: 14, fontWeight: 600 }}>ao vivo</span></span>
                <span className="lbl">CS humano até conclusão</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* MARQUEE */}
      <div className="marquee" aria-hidden>
        <div className="marquee-track" id="marqTrack">
          <div className="marquee-item"><span className="plus">+</span> <b>Whitelabel próprio</b> com domínio seu</div>
          <div className="marquee-item"><span className="plus">+</span> 10% <b>por êxito</b>, só paga se vender</div>
          <div className="marquee-item"><span className="plus">+</span> Sem mensalidade, sem <b>fidelidade</b>, sem multa</div>
          <div className="marquee-item"><span className="plus">+</span> CS humano até a <b>conclusão</b></div>
          <div className="marquee-item"><span className="plus">+</span> Aceito <b>ofício</b>, recuso fantasia</div>
          <div className="marquee-item"><span className="plus">+</span> Dossiê <b>padronizado</b> como fonte única</div>
          <div className="marquee-item"><span className="plus">+</span> Pare de publicar a <b>versão diluída</b> de você</div>
          <div className="marquee-item"><span className="plus">+</span> 10% pra ter o <b>negócio inteiro</b></div>
        </div>
      </div>

      {/* JORNADA */}
      <section className="t-section" id="jornada">
        <div className="t-shell">
          <div className="t-section-head">
            <span className="kicker">Como funciona</span>
            <h2>5 fases dentro do Pacote DFY</h2>
            <p>Não tem etapa cobrada à parte. Não tem upsell escondido. O que vem abaixo é o cronograma interno do pacote que você contrata — do dia 1 ao último entregável.</p>
          </div>
          <div className="journey-wrap">
            <div className="journey">
              <div className="step done">
                <span className="step-num"><span className="step-dot" /> Fase 01</span>
                <h4>Mapa de Contexto</h4>
                <span className="step-price">Incluso</span>
                <p className="step-desc">Mapa de Contexto base via fluxo de IA</p>
              </div>
              <div className="step active">
                <span className="step-num"><span className="step-dot" /> Fase 02</span>
                <h4>Sessão do Tácito</h4>
                <span className="step-price">Incluso</span>
                <p className="step-desc">Meet 90-120min para extrair o que ainda mora só na sua cabeça</p>
              </div>
              <div className="step active">
                <span className="step-num"><span className="step-dot" /> Fase 03</span>
                <h4>Mapa do Ecossistema</h4>
                <span className="step-price">Incluso</span>
                <p className="step-desc">Dossiê completo: posicionamento, persona, iscas, funis, esteira</p>
              </div>
              <div className="step">
                <span className="step-num"><span className="step-dot" /> Fase 04</span>
                <h4>Implantação</h4>
                <span className="step-price">Incluso</span>
                <p className="step-desc">Construímos os ativos, iscas e funis prontos para operar</p>
              </div>
              <div className="step">
                <span className="step-num"><span className="step-dot" /> Fase 05</span>
                <h4>Operação</h4>
                <span className="step-price">CS + Comunidade</span>
                <p className="step-desc">Acompanhamento até conclusão, acesso a todos os cursos</p>
              </div>
            </div>
            <div className="you-here">
              <span className="you-here-pill"><span className="plus" /> <b>Tudo isso já está incluso no Pacote DFY que você contrata.</b></span>
              <span className="you-here-note">Você paga uma vez. As cinco fases acontecem por dentro.</span>
            </div>
          </div>
        </div>
      </section>

      {/* DOSSIE */}
      <section className="t-section" id="dossie">
        <div className="t-shell-narrow">
          <div className="t-section-head">
            <span className="kicker">O que fazemos agora</span>
            <h2>O Dossiê do Expert</h2>
            <p>Antes de construir qualquer ativo, é preciso saber o que construir. O dossiê é onde a estratégia nasce. Ele é a base de TUDO que vem depois.</p>
          </div>
          <div className="dossier">
            <article className="dcard">
              <div className="dcard-head">
                <span className="pill pill-mono pill-pink">Fase 01</span>
                <h3>Extrator de Contexto</h3>
                <div className="dcard-price">
                  <span className="v gratis">Grátis</span>
                  <span className="sub">na primeira execução</span>
                </div>
                <span className="t-mono" style={{ color: 'var(--ink-4)' }}>R$ 19,90 nas tentativas adicionais</span>
              </div>
              <div className="dcard-body">
                <p>Fluxo guiado por IA que faz <strong>10 perguntas estratégicas</strong> sobre o seu negócio. O Jhow (nossa IA) trabalha como um entrevistador experiente: extrai posicionamento, persona, inimigo, método, vocabulário e diferenciais. Ao final, gera o seu <strong>Mapa de Contexto base</strong>.</p>
                <div className="dcard-grid">
                  <div className="cell"><div className="lbl">Você entrega</div><div className="txt">30-60 minutos respondendo. No seu ritmo, no celular ou desktop.</div></div>
                  <div className="cell"><div className="lbl">Você recebe</div><div className="txt">Mapa de Contexto inicial com 25 blocos visuais (acessível em /app/biblioteca).</div></div>
                  <div className="cell"><div className="lbl">Onde acessa</div><div className="txt">No app eBuz. Pode revisar, refazer e exportar quando quiser.</div></div>
                </div>
              </div>
            </article>

            <article className="dcard featured">
              <div className="dcard-head">
                <span className="pill pill-mono pill-pink">Etapa 02 · Coração do processo</span>
                <h3>Sessão do Tácito</h3>
                <div className="dcard-price">
                  <span className="v">R$ 500</span>
                  <span className="sub">Pix à vista · 90-120min por Meet</span>
                </div>
              </div>
              <div className="dcard-body">
                <p>Conversa profunda com o Jonathan usando <strong>Critical Decision Method (Gary Klein)</strong>, técnica usada para extrair o conhecimento que já é tão automático no expert que ele mesmo não enxerga mais. São 5 blocos: decisões tácitas, histórias com arco, voz e linguagem, mercado e indignação, ecossistema e propósito.</p>
                <div className="dcard-grid">
                  <div className="cell"><div className="lbl">O que extraímos</div><div className="txt">Bordões, casos com nome, decisões automáticas, vocabulário-assinatura.</div></div>
                  <div className="cell"><div className="lbl">Como conduzimos</div><div className="txt">Conversa dirigida, sem script visível. Provocações que quebram modo apresentação.</div></div>
                  <div className="cell"><div className="lbl">Por que importa</div><div className="txt">Sem o tácito, qualquer ativo construído soa genérico. É aqui que sai a alma.</div></div>
                </div>
              </div>
            </article>

            <article className="dcard">
              <div className="dcard-head">
                <span className="pill pill-mono pill-pink">Fase 03</span>
                <h3>Mapa do Ecossistema</h3>
                <div className="dcard-price">
                  <span className="v gratis">Incluso na Sessão</span>
                  <span className="sub">Entregue em até 5 dias úteis</span>
                </div>
              </div>
              <div className="dcard-body">
                <p>Documento estratégico completo (o <strong>Dossiê do Expert</strong>) gerado a partir do que apareceu na sessão. Não é resumo: é a base operacional de toda a implantação que vem depois. Contém todos os elementos abaixo, organizados em formato visual interativo:</p>
                <div className="dcard-tags">
                  {[
                    'Posicionamento + Tese','Inimigo nomeado','Método com pilares','Persona dissecada',
                    '15 personas NxC','Vocabulário oficial','Dicionário próprio','18 iscas mapeadas',
                    'Funis sugeridos','Ativos prioritários','Esteira completa','Lacunas a fechar',
                  ].map((t) => <span key={t} className="pill">{t}</span>)}
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* DARK CTA */}
      <section className="t-section" style={{ borderTop: 0, paddingTop: 0 }}>
        <div className="t-shell">
          <div className="dark-cta">
            <div className="dark-cta-inner">
              <span className="kicker"><span className="plus" /> Dossiê concluído <span className="plus" /></span>
              <h2>Você sabe exatamente o que construir.<br /><span className="t-grad-text">Agora vamos construir.</span></h2>
              <p>Com o Mapa do Ecossistema na mão, a eBuz implanta tudo pronto pra operar: ativos, iscas, funis e plataforma — entrega fechada com prazo definido e CS até o último entregável.</p>
              <div className="dark-cta-actions">
                <a className="t-btn t-btn-primary t-btn-lg" href="#pacotes">Ver pacotes de implantação</a>
                <a className="t-btn t-btn-ghost-light t-btn-lg" href="#calculadora">Montar pacote sob medida</a>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* PACOTES */}
      <section className="t-section" id="pacotes">
        <div className="t-shell">
          <div className="t-section-head">
            <span className="kicker">Pacotes Done-For-You</span>
            <h2>10% pra ter o negócio inteiro.<br/>Não 10% pra ter um link na marca dos outros.</h2>
            <p>Três tiers. Mesma fábrica. Todos são ecossistema completo dentro do Whitelabel eBuz — domínio próprio, área de membros, checkout no seu nome. A diferença entre eles é escopo, não qualidade.</p>
          </div>

          <div className="packs">
            <article className="pack">
              <div className="pack-head">
                <span className="pill pill-mono">Pacote · Inicial</span>
                <h3>Ignição</h3>
                <div className="pack-price"><span className="v">R$ 4.500</span></div>
                  </div>
              <ul className="pack-features">
                {['Mapa do Ecossistema + Sessão do Tácito com Jonathan','2 ativos à escolha (livro, curso, mentoria, palestra ou comunidade)','3 iscas calibradas pela sua Tese Vivida','1 funil simples','Whitelabel completo (domínio próprio + área de membros + checkout Asaas)','1 semestre na Comunidade eBuz','CS humano até a última entrega']
                  .map((t) => <li key={t}><Check /> {t}</li>)}
              </ul>
              <div className="pack-meta">
                <div className="row"><span className="lbl">Prazo</span><span className="val">4-6 semanas</span></div>
                <div className="row"><span className="lbl">Depois</span><span className="val">10% perpétuo via split do Asaas</span></div>
              </div>
              <a className="t-btn t-btn-ghost t-btn-lg" href="https://ebuz.com.br/passo1">Quero conversar sobre o Ignição <Arrow /></a>
            </article>

            <article className="pack pack-popular">
              <span className="pack-badge">Mais popular</span>
              <div className="pack-head">
                <span className="pill pill-mono pill-pink">Pacote · Intermediário</span>
                <h3>Pro</h3>
                <div className="pack-price"><span className="v">R$ 13.500</span></div>
                  </div>
              <ul className="pack-features">
                {['Tudo do Ignição','4 ativos à escolha (livro, curso, mentoria, palestra, comunidade)','8 iscas (Conversão + Qualificação + Posicionamento)','2 funis (1 simples + 1 complexo ou de lançamento)','Dossiê do Expert padronizado','Integrações Meta CAPI + Google Tag Manager','1 semestre na Comunidade eBuz']
                  .map((t) => <li key={t}><Check /> {t}</li>)}
              </ul>
              <div className="pack-meta">
                <div className="row"><span className="lbl">Prazo</span><span className="val">8-12 semanas</span></div>
                <div className="row"><span className="lbl">Depois</span><span className="val">10% perpétuo via split do Asaas</span></div>
              </div>
              <a className="t-btn t-btn-primary t-btn-lg" href="https://ebuz.com.br/passo1">Quero conversar sobre o Pro <Arrow /></a>
            </article>

            <article className="pack">
              <div className="pack-head">
                <span className="pill pill-mono">Pacote · Completo</span>
                <h3>Premium</h3>
                <div className="pack-price"><span className="v">R$ 29.900</span></div>
                  </div>
              <ul className="pack-features">
                {['Tudo do Pro','5 ativos (catálogo completo: livro, curso, mentoria, palestra, comunidade)','15 iscas calibradas','3 funis (simples, complexo e de lançamento)','Sessão do Tácito ampliada (sessões aprofundadas com Jonathan)','12 meses na Comunidade eBuz','Parcelável em até 6x']
                  .map((t) => <li key={t}><Check /> {t}</li>)}
              </ul>
              <div className="pack-meta">
                <div className="row"><span className="lbl">Prazo</span><span className="val">16-20 semanas</span></div>
                <div className="row"><span className="lbl">Depois</span><span className="val">10% perpétuo via split do Asaas</span></div>
              </div>
              <a className="t-btn t-btn-dark t-btn-lg" href="https://ebuz.com.br/passo1">Quero conversar sobre o Premium <Arrow /></a>
            </article>
          </div>

          <div className="pack-fineprint">
            <strong>10% perpétuo via split do Asaas:</strong> recorrência só sobre vendas, automática. Sem mensalidade, sem fidelidade, sem multa. Cliente que parar de vender, para de pagar.
            <br /><br />
            <strong>Ferramentas externas:</strong> eBuz configura, integra e documenta toda a lógica de email e WhatsApp. A assinatura das ferramentas (ActiveCampaign, ManyChat, etc.) é por conta do expert.
          </div>

          {/* Matriz comparativa toggle */}
          <div className="matrix" id="matrix" hidden>
            <table>
              <thead>
                <tr>
                  <th style={{ minWidth: 240 }}>O que está incluso</th>
                  <th className="center">Ignição</th>
                  <th className="center col-pop">Pro</th>
                  <th className="center">Premium</th>
                </tr>
              </thead>
              <tbody>
                <tr><td className="feat">Mapa de Contexto + Sessão do Tácito</td><td className="center"><span className="check">●</span></td><td className="center col-pop"><span className="check">●</span></td><td className="center"><span className="check">●</span></td></tr>
                <tr><td className="feat">Ativos construídos</td><td className="center">2</td><td className="center col-pop">4</td><td className="center">5</td></tr>
                <tr><td className="feat">Iscas implementadas</td><td className="center">3</td><td className="center col-pop">8</td><td className="center">15</td></tr>
                <tr><td className="feat">Funis estruturados</td><td className="center">1 simples</td><td className="center col-pop">2</td><td className="center">3</td></tr>
                <tr><td className="feat">Whitelabel completo (domínio próprio + checkout Asaas)</td><td className="center"><span className="check">●</span></td><td className="center col-pop"><span className="check">●</span></td><td className="center"><span className="check">●</span></td></tr>
                <tr><td className="feat">Comunidade eBuz inclusa</td><td className="center">6 meses</td><td className="center col-pop">6 meses</td><td className="center">12 meses</td></tr>
                <tr><td className="feat">CS humano até conclusão</td><td className="center"><span className="check">●</span></td><td className="center col-pop"><span className="check">●</span></td><td className="center"><span className="check">●</span></td></tr>
                <tr><td className="feat">10% perpétuo (sem mensalidade)</td><td className="center"><span className="check">●</span></td><td className="center col-pop"><span className="check">●</span></td><td className="center"><span className="check">●</span></td></tr>
                <tr><td className="feat">Prazo médio de entrega</td><td className="center">4-6 sem</td><td className="center col-pop">8-12 sem</td><td className="center">16-20 sem</td></tr>
                <tr className="row-price"><td>Investimento total</td><td className="center">R$ 4.500</td><td className="center col-pop">R$ 13.500</td><td className="center">R$ 29.900</td></tr>
              </tbody>
            </table>
          </div>
          <div className="matrix-toggle">
            <button className="t-btn t-btn-ghost t-btn-sm" id="matrixBtn" type="button" onClick={matrixToggle}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M3 6h18"/><path d="M3 12h18"/><path d="M3 18h18"/></svg>
              <span>Ver matriz comparativa completa</span>
            </button>
          </div>
        </div>
      </section>

      {/* ISCAS */}
      <section className="t-section" id="iscas">
        <div className="t-shell">
          <div className="t-section-head">
            <span className="kicker">Iscas de Marketing</span>
            <h2>18 iscas por impacto</h2>
            <p>Clique em qualquer isca para abrir o guia completo: o que é, quando usar, a estrutura bloco a bloco e os erros a evitar.</p>
          </div>
          <p className="iscas-disclaimer">Ferramentas externas (email, quiz, automação) = expert paga a assinatura. eBuz configura.</p>

          <div className="iscas-cat">
            <div className="iscas-cat-head">
              <div className="left"><span className="cat-mark cat-conv" /><h3>Conversão</h3></div>
              <span className="sub">fecham vendas diretamente</span>
            </div>
            <div className="iscas-grid">
              {ISCAS_CONV.map((i) => (
                <a key={i.nome} id={i.slug} href={`/blog/isca-${i.slug}`} className="isca">
                  <div className="isca-row"><h4>{i.nome}</h4><span className="price">{i.preco}</span></div>
                  <p className="desc">{i.desc}</p>
                  <span className="more">ler o guia completo →</span>
                </a>
              ))}
            </div>
          </div>

          <div className="iscas-cat">
            <div className="iscas-cat-head">
              <div className="left"><span className="cat-mark cat-qual" /><h3>Qualificação</h3></div>
              <span className="sub">geram e nutrem leads</span>
            </div>
            <div className="iscas-grid">
              {ISCAS_QUAL.map((i) => (
                <a key={i.nome} id={i.slug} href={`/blog/isca-${i.slug}`} className="isca">
                  <div className="isca-row"><h4>{i.nome}</h4><span className="price">{i.preco}</span></div>
                  <p className="desc">{i.desc}</p>
                  <span className="more">ler o guia completo →</span>
                </a>
              ))}
            </div>
          </div>

          <div className="iscas-cat">
            <div className="iscas-cat-head">
              <div className="left"><span className="cat-mark cat-pos" /><h3>Posicionamento</h3></div>
              <span className="sub">constroem autoridade</span>
            </div>
            <div className="iscas-grid">
              {ISCAS_POS.map((i) => (
                <a key={i.nome} id={i.slug} href={`/blog/isca-${i.slug}`} className="isca">
                  <div className="isca-row"><h4>{i.nome}</h4><span className="price">{i.preco}</span></div>
                  <p className="desc">{i.desc}</p>
                  <span className="more">ler o guia completo →</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FUNIS */}
      <section className="t-section" id="funis">
        <div className="t-shell">
          <div className="t-section-head">
            <span className="kicker">Funis</span>
            <h2>Conexão entre iscas e ativos</h2>
            <p>Funil não inclui as iscas. Iscas são compradas separadamente.</p>
          </div>

          <div className="funis">
            <article className="funil">
              <span className="pill pill-mono">Funil simples</span>
              <h3>Simples</h3>
              <span className="price">R$ 1.200</span>
              <p className="desc">Caminho linear: 2-3 iscas conectadas, 1 automação, 1 página e métricas. Para validar primeiro pipeline.</p>
              <div className="funil-flow">
                <span className="step-pill">isca</span><Arrow />
                <span className="step-pill">página</span><Arrow />
                <span className="step-pill">automação</span><Arrow />
                <span className="step-pill">venda</span>
              </div>
              <div className="funil-svg">
                <svg viewBox="0 0 320 90" xmlns="http://www.w3.org/2000/svg">
                  <defs><marker id="a1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6" fill="#9CA3B0"/></marker></defs>
                  <g fontFamily="ui-monospace,monospace" fontSize="10" fill="#43474D">
                    <circle cx="30" cy="45" r="22" fill="#fff5f8" stroke="#EF3476" strokeWidth="1.5"/>
                    <text x="30" y="48" textAnchor="middle" fill="#EF3476" fontWeight="600">isca</text>
                    <line x1="54" y1="45" x2="96" y2="45" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a1)"/>
                    <rect x="100" y="28" width="54" height="34" rx="6" fill="#fff" stroke="#E6E1D7"/>
                    <text x="127" y="49" textAnchor="middle">página</text>
                    <line x1="156" y1="45" x2="196" y2="45" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a1)"/>
                    <rect x="200" y="28" width="66" height="34" rx="6" fill="#fff" stroke="#E6E1D7"/>
                    <text x="233" y="49" textAnchor="middle">automação</text>
                    <line x1="268" y1="45" x2="294" y2="45" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a1)"/>
                    <circle cx="308" cy="45" r="10" fill="#1FB870"/>
                    <text x="308" y="48" textAnchor="middle" fill="#fff" fontSize="8" fontWeight="700">$</text>
                  </g>
                </svg>
              </div>
            </article>

            <article className="funil featured">
              <span className="pill pill-mono pill-pink">Funil complexo · vende 24h</span>
              <h3>Complexo</h3>
              <span className="price">R$ 3.500</span>
              <p className="desc">Múltiplas entradas, caminhos alternativos, automação segmentada por tag, VSL perpétuo, retargeting e recuperação. Vende 24h sem o expert.</p>
              <div className="funil-flow">
                <span className="step-pill">multi-iscas</span><Arrow />
                <span className="step-pill">tags</span><Arrow />
                <span className="step-pill">VSL</span><Arrow />
                <span className="step-pill">retarget</span>
              </div>
              <div className="funil-svg">
                <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg">
                  <defs><marker id="a2" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6" fill="#9CA3B0"/></marker></defs>
                  <g fontFamily="ui-monospace,monospace" fontSize="9" fill="#43474D">
                    <circle cx="22" cy="24" r="14" fill="#fff5f8" stroke="#EF3476" strokeWidth="1.4"/>
                    <circle cx="22" cy="60" r="14" fill="#fff5f8" stroke="#EF3476" strokeWidth="1.4"/>
                    <circle cx="22" cy="96" r="14" fill="#fff5f8" stroke="#EF3476" strokeWidth="1.4"/>
                    <text x="22" y="27" textAnchor="middle" fill="#EF3476">i1</text>
                    <text x="22" y="63" textAnchor="middle" fill="#EF3476">i2</text>
                    <text x="22" y="99" textAnchor="middle" fill="#EF3476">i3</text>
                    <path d="M36 24 Q60 24 70 60" fill="none" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a2)"/>
                    <path d="M36 60 L70 60" fill="none" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a2)"/>
                    <path d="M36 96 Q60 96 70 60" fill="none" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a2)"/>
                    <rect x="78" y="44" width="50" height="32" rx="6" fill="#fff" stroke="#E6E1D7"/>
                    <text x="103" y="63" textAnchor="middle">tags</text>
                    <line x1="130" y1="60" x2="160" y2="60" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a2)"/>
                    <rect x="164" y="44" width="46" height="32" rx="6" fill="#0a0a0b"/>
                    <text x="187" y="63" textAnchor="middle" fill="#fff">VSL</text>
                    <path d="M210 76 Q220 100 232 100" fill="none" stroke="#EF3476" strokeWidth="1.2" strokeDasharray="3 3" markerEnd="url(#a2)"/>
                    <rect x="232" y="86" width="58" height="22" rx="5" fill="#fff5f8" stroke="#EF3476"/>
                    <text x="261" y="100" textAnchor="middle" fill="#EF3476">retarget</text>
                    <line x1="210" y1="60" x2="294" y2="60" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a2)"/>
                    <circle cx="305" cy="60" r="10" fill="#1FB870"/>
                    <text x="305" y="63" textAnchor="middle" fill="#fff" fontSize="8" fontWeight="700">$</text>
                  </g>
                </svg>
              </div>
            </article>

            <article className="funil">
              <span className="pill pill-mono">Funil de lançamento</span>
              <h3>Lançamento</h3>
              <span className="price">R$ 5.000</span>
              <p className="desc">CPL e janela de vagas. Timeline dia a dia, emails, urgência e pesquisa de saída. Exige audiência mínima de 200-300 leads aquecidos.</p>
              <div className="funil-flow">
                <span className="step-pill">CPL 1</span><Arrow />
                <span className="step-pill">CPL 2</span><Arrow />
                <span className="step-pill">CPL 3</span><Arrow />
                <span className="step-pill">vagas</span>
              </div>
              <div className="funil-svg">
                <svg viewBox="0 0 320 90" xmlns="http://www.w3.org/2000/svg">
                  <defs><marker id="a3" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6" fill="#9CA3B0"/></marker></defs>
                  <g fontFamily="ui-monospace,monospace" fontSize="10" fill="#fff" fontWeight="600">
                    <rect x="6" y="30" width="54" height="34" rx="6" fill="#0a0a0b"/>
                    <text x="33" y="51" textAnchor="middle">CPL 1</text>
                    <line x1="60" y1="47" x2="82" y2="47" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a3)"/>
                    <rect x="86" y="30" width="54" height="34" rx="6" fill="#0a0a0b"/>
                    <text x="113" y="51" textAnchor="middle">CPL 2</text>
                    <line x1="140" y1="47" x2="162" y2="47" stroke="#9CA3B0" strokeWidth="1.2" markerEnd="url(#a3)"/>
                    <rect x="166" y="30" width="54" height="34" rx="6" fill="#0a0a0b"/>
                    <text x="193" y="51" textAnchor="middle">CPL 3</text>
                    <line x1="220" y1="47" x2="242" y2="47" stroke="#EF3476" strokeWidth="1.4" markerEnd="url(#a3)"/>
                    <rect x="246" y="22" width="66" height="50" rx="6" fill="#EF3476"/>
                    <text x="279" y="43" textAnchor="middle" fontSize="9">JANELA</text>
                    <text x="279" y="57" textAnchor="middle" fontSize="11" fontWeight="700">vagas</text>
                  </g>
                </svg>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* RULES */}
      <section className="t-section">
        <div className="t-shell">
          <div className="rules">
            <div className="rules-inner">
              <div className="rules-head">
                <span className="kicker"><span className="plus plus-white" /> Como funciona</span>
              </div>
              <h2>Regras comerciais</h2>
              <ul className="rules-grid">
                {[
                  'Sem recorrência. Tudo é pacote com entrega fechada.',
                  'CS acompanha até último entregável. Depois, 7 dias de suporte.',
                  'Automações de email e WhatsApp: eBuz configura a lógica e os fluxos. Assinatura da ferramenta (ActiveCampaign, ManyChat) é por conta do expert.',
                  'Plataforma e checkout integrados, só com Sistema contratado.',
                  'Sistema (App): custo de servidor (Supabase, Vercel, domínio) é variável e pago pelo expert. Manutenção inclusa por 6 meses.',
                  'Sem gestão de tráfego. eBuz não gerencia anúncios.',
                  'Renovação é novo pacote, pode ser avulso ou pacote completo.',
                ].map((t) => (
                  <li key={t}><span className="plus plus-white" /> {t}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CALCULADORA — oculta (v2 restart) */}
      <section className="t-section" id="calculadora" style={{ display: 'none' }}>
        <div className="t-shell-narrow">
          <div className="t-section-head">
            <span className="kicker">Calculadora</span>
            <h2>Monte seu pacote</h2>
            <p>Selecione ativos, iscas e funis. Vemos o investimento total em tempo real. Use para sair da Sessão do Tácito com ideia clara de orçamento.</p>
          </div>
          <div className="calc">
            <div className="calc-left">
              <div className="calc-section">
                <span className="lbl">+ Ativos</span>
                <div className="calc-options" data-group="ativos">
                  {CALC_ATIVOS.map((it) => (
                    <button key={it.name} type="button" className="calc-opt" data-name={it.name} data-price={it.price} onClick={calcToggle}>
                      {it.name} <span className="calc-opt-price">R$ {it.price.toLocaleString('pt-BR')}</span>
                    </button>
                  ))}
                </div>
              </div>
              <div className="calc-section">
                <span className="lbl">+ Iscas</span>
                <div className="calc-options" data-group="iscas">
                  {CALC_ISCAS.map((it) => (
                    <button key={it.name} type="button" className="calc-opt" data-name={it.name} data-price={it.price} onClick={calcToggle}>
                      {it.name} <span className="calc-opt-price">R$ {it.price.toLocaleString('pt-BR')}</span>
                    </button>
                  ))}
                </div>
              </div>
              <div className="calc-section">
                <span className="lbl">+ Funis</span>
                <div className="calc-options" data-group="funis">
                  {CALC_FUNIS.map((it) => (
                    <button key={it.name} type="button" className="calc-opt" data-name={it.name} data-price={it.price} onClick={calcToggle}>
                      {it.name} <span className="calc-opt-price">R$ {it.price.toLocaleString('pt-BR')}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="calc-right">
              <div className="calc-right-inner">
                <div>
                  <span className="lbl" style={{ color: 'rgba(255,255,255,.55)', fontFamily: 'var(--tmono)', fontSize: 10, letterSpacing: '.16em', textTransform: 'uppercase', fontWeight: 600 }}>Resumo</span>
                  <h3 style={{ color: '#fff', marginTop: 6, fontFamily: 'var(--tdisplay)', fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em' }}>Seu pacote sob medida</h3>
                </div>
                <div className="calc-summary" id="calcSummary">
                  <p className="calc-empty">Comece selecionando os ativos que você precisa →</p>
                </div>
                <div className="calc-total-block">
                  <span className="calc-total-lbl">Investimento estimado</span>
                  <div className="calc-total" id="calcTotal">R$ 0</div>
                  <p className="calc-hint">Pacote completo (Ignição/Estrutura/Ecossistema) traz desconto progressivo. Conversamos na Sessão.</p>
                  <a className="t-btn t-btn-primary t-btn-sm" style={{ marginTop: 14 }} href="https://ebuz.com.br/passo1">
                    <Arrow /> Levar para a Sessão
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="t-section" id="faq">
        <div className="t-shell-narrow">
          <div className="t-section-head">
            <span className="kicker">Perguntas frequentes</span>
            <h2>Antes de você perguntar</h2>
            <p>O que mais sai na Sessão do Tácito. Já respondemos aqui pra você decidir com clareza.</p>
          </div>
          <div className="faq">
            {FAQS.map((f) => (
              <div key={f.q} className="faq-item">
                <div className="faq-q" onClick={faqClick}>
                  {f.q}
                  <span className="faq-icon"><PlusIcon /></span>
                </div>
                <div className="faq-a"><p>{f.a}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="t-section" style={{ borderTop: 0 }}>
        <div className="t-shell">
          <div className="final-cta">
            <div className="final-cta-inner">
              <span className="kicker"><span className="plus" /> Começar · 30 minutos · zero compromisso <span className="plus" /></span>
              <h2>Você pagou cinco dígitos no ano passado pra publicar uma versão diluída de si mesmo.<br/>O Mapa de Contexto é grátis. Trinta minutos.</h2>
              <p>Quando terminar, você tem vocabulário pra reconhecer o que estava errado nas terceirizadas que te decepcionaram — e clareza pra decidir se vale agendar Reunião de Confronto. Sem assinar nada. Sem call obrigatória. Sem cadeia de e-mails.</p>
              <div className="final-cta-actions">
                <a className="t-btn t-btn-lg final-cta-white" href="https://ebuz.com.br/passo1">Começar pelo Mapa de Contexto · Grátis <Arrow /></a>
                <a className="t-btn t-btn-ghost-light t-btn-lg" href="https://wa.me/5569993333302?text=Vim%20da%20tabela%20e%20quero%20entender%20melhor%20o%20processo" target="_blank" rel="noopener noreferrer">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                  Falar no WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="foot">
        ebuz negócios digitais <span className="sep">·</span> Implantação de Ecossistema · v6.0 <span className="sep">·</span> Sem mensalidade. Sem fidelidade. Sem multa. Só êxito.
      </footer>
    </div>
  )
}

const TABELA_CSS = `
.tabela-root{
  --rose-1:#EF3476; --rose-2:#EA7F76;
  --grad: linear-gradient(135deg,#EF3476 0%,#EA7F76 100%);
  --paper:#f6f4ef; --paper-2:#fafaf7; --line:#e6e3dd; --line-2:#efece5;
  --ink-0:#0a0a0b; --ink-1:#1a1a1d; --ink-2:#2a2a2e; --ink-3:#4a4a52;
  --ink-4:#71717a; --ink-5:#a1a1aa; --ink-6:#d4d4d8; --ink-7:#e8e8ec;
  --ink-8:#f4f4f6; --ink-9:#fafafb; --white:#ffffff;
  --ok:#1f8a5b; --warn:#c8881d;
  --tdisplay: var(--font-sora,'Sora'),ui-sans-serif,system-ui;
  --ttext: var(--font-manrope,'Manrope'),ui-sans-serif,system-ui;
  --tmono: var(--font-jetbrains-mono,'JetBrains Mono'),ui-monospace,monospace;
  --r-xs:6px; --r-sm:10px; --r:14px; --r-lg:20px; --r-xl:28px;
  --shadow-soft:0 1px 2px rgba(10,10,11,.04), 0 4px 14px -4px rgba(10,10,11,.06);
  --shadow-card:0 1px 2px rgba(10,10,11,.04), 0 8px 24px -12px rgba(10,10,11,.10);
  --shadow-glow:0 8px 24px -8px rgba(239,52,118,.4);
  --shadow-xglow:0 16px 48px -12px rgba(239,52,118,.55);
  background:var(--paper);color:var(--ink-1);font-family:var(--ttext);font-size:15px;line-height:1.55;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility
}
.tabela-root *,.tabela-root *::before,.tabela-root *::after{box-sizing:border-box}
.tabela-root a{color:inherit;text-decoration:none}
.tabela-root button{font:inherit;color:inherit;background:none;border:0;padding:0;cursor:pointer}
.tabela-root .t-mono{font-family:var(--tmono);font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-4);font-weight:500}
.tabela-root h1,.tabela-root h2,.tabela-root h3,.tabela-root h4{font-family:var(--tdisplay);color:var(--ink-0);margin:0;text-wrap:balance}
.tabela-root h1{font-size:clamp(40px,5.6vw,68px);font-weight:700;letter-spacing:-0.035em;line-height:0.98}
.tabela-root h2{font-size:clamp(28px,3.6vw,46px);font-weight:600;letter-spacing:-0.025em;line-height:1.05}
.tabela-root h3{font-size:22px;font-weight:600;letter-spacing:-0.015em;line-height:1.2}
.tabela-root h4{font-size:17px;font-weight:600;letter-spacing:-0.01em;line-height:1.25}
.tabela-root p{color:var(--ink-3);text-wrap:pretty;margin:0}
.tabela-root .t-grad-text{background:var(--grad);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent}
.tabela-root .t-shell{max-width:1200px;margin:0 auto;padding:0 28px}
.tabela-root .t-shell-narrow{max-width:1080px;margin:0 auto;padding:0 28px}
.tabela-root .t-section{padding:96px 0;border-top:1px solid var(--line)}
.tabela-root .t-section:first-of-type{border-top:0}
.tabela-root .t-section-head{text-align:center;margin-bottom:56px;display:flex;flex-direction:column;align-items:center;gap:14px}
.tabela-root .t-section-head .kicker{font-family:var(--tmono);font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:var(--rose-1);font-weight:600}
.tabela-root .t-section-head h2{max-width:720px}
.tabela-root .t-section-head p{max-width:640px;color:var(--ink-3);font-size:15.5px}
.tabela-root .topnav{position:sticky;top:0;z-index:30;background:rgba(246,244,239,.85);backdrop-filter:blur(14px);border-bottom:1px solid var(--line)}
.tabela-root .topnav-inner{max-width:1200px;margin:0 auto;padding:14px 28px;display:flex;align-items:center;gap:24px}
.tabela-root .brand{display:flex;align-items:center;gap:10px}
.tabela-root .brand-mark{width:30px;height:30px;border-radius:8px;background:var(--grad);position:relative;flex:none;box-shadow:var(--shadow-glow)}
.tabela-root .brand-mark::before,.tabela-root .brand-mark::after{content:"";position:absolute;background:#fff;border-radius:1px}
.tabela-root .brand-mark::before{left:50%;top:22%;width:2.5px;height:56%;transform:translateX(-50%)}
.tabela-root .brand-mark::after{top:50%;left:22%;height:2.5px;width:56%;transform:translateY(-50%)}
.tabela-root .brand-text{font-family:var(--tdisplay);font-weight:700;font-size:15px;letter-spacing:-0.02em;color:var(--ink-0);line-height:1.1}
.tabela-root .brand-text small{display:block;font-family:var(--tmono);font-size:9px;letter-spacing:.18em;color:var(--ink-4);font-weight:500;margin-top:1px;text-transform:uppercase}
.tabela-root .topnav-links{display:flex;gap:6px;margin-left:auto}
.tabela-root .topnav-links a{font-size:13px;color:var(--ink-3);padding:8px 12px;border-radius:8px;font-weight:500}
.tabela-root .topnav-links a:hover{color:var(--ink-1);background:var(--paper-2)}
.tabela-root .t-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:var(--ttext);font-weight:600;font-size:14px;letter-spacing:-0.005em;padding:11px 20px;border-radius:999px;border:1px solid transparent;cursor:pointer;transition:transform .12s ease,box-shadow .15s ease,background .15s ease;white-space:nowrap}
.tabela-root .t-btn-primary{background:var(--grad);color:#fff;box-shadow:var(--shadow-glow)}
.tabela-root .t-btn-primary:hover{transform:translateY(-1px);box-shadow:var(--shadow-xglow)}
.tabela-root .t-btn-dark{background:var(--ink-0);color:#fff}
.tabela-root .t-btn-dark:hover{background:var(--ink-1);transform:translateY(-1px)}
.tabela-root .t-btn-ghost{background:var(--white);color:var(--ink-1);border-color:var(--line)}
.tabela-root .t-btn-ghost:hover{background:var(--paper-2)}
.tabela-root .t-btn-ghost-light{background:rgba(255,255,255,.1);color:#fff;border-color:rgba(255,255,255,.18)}
.tabela-root .t-btn-ghost-light:hover{background:rgba(255,255,255,.16)}
.tabela-root .t-btn-lg{padding:14px 26px;font-size:15px}
.tabela-root .t-btn-sm{padding:8px 14px;font-size:13px}
.tabela-root .pill{display:inline-flex;align-items:center;gap:6px;padding:5px 12px;border-radius:999px;font-size:12px;font-weight:500;background:var(--white);border:1px solid var(--line);color:var(--ink-2)}
.tabela-root .pill-mono{font-family:var(--tmono);font-size:10px;letter-spacing:.14em;text-transform:uppercase;font-weight:600}
.tabela-root .pill-pink{background:rgba(239,52,118,.08);color:var(--rose-1);border-color:rgba(239,52,118,.18)}
.tabela-root .pill-light{background:rgba(255,255,255,.1);color:#fff;border-color:rgba(255,255,255,.18)}
.tabela-root .plus{position:relative;width:14px;height:14px;flex-shrink:0;display:inline-block}
.tabela-root .plus::before,.tabela-root .plus::after{content:'';position:absolute;background:var(--rose-1)}
.tabela-root .plus::before{left:50%;top:0;width:1.5px;height:100%;transform:translateX(-50%)}
.tabela-root .plus::after{top:50%;left:0;height:1.5px;width:100%;transform:translateY(-50%)}
.tabela-root .plus-white::before,.tabela-root .plus-white::after{background:#fff}

/* Reveal */
.tabela-root .reveal{opacity:0;transform:translateY(24px);transition:opacity .8s cubic-bezier(.2,.7,.2,1),transform .8s cubic-bezier(.2,.7,.2,1)}
.tabela-root .reveal.in{opacity:1;transform:translateY(0)}
.tabela-root .reveal-delay-1{transition-delay:.08s}
.tabela-root .reveal-delay-2{transition-delay:.16s}
.tabela-root .reveal-delay-3{transition-delay:.24s}

/* HERO */
.tabela-root .hero{position:relative;background:var(--ink-0);color:#fff;overflow:hidden;padding:140px 0 120px;border-top:0}
.tabela-root .hero::before{content:"";position:absolute;inset:0;opacity:.4;background-image:linear-gradient(rgba(255,255,255,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.05) 1px,transparent 1px);background-size:48px 48px;-webkit-mask-image:radial-gradient(ellipse at 50% 30%,#000 30%,transparent 75%);mask-image:radial-gradient(ellipse at 50% 30%,#000 30%,transparent 75%)}
.tabela-root .hero-mesh{position:absolute;inset:0;pointer-events:none;z-index:0}
.tabela-root .hero-mesh::before{content:"";position:absolute;left:var(--mx,50%);top:var(--my,30%);width:900px;height:900px;border-radius:50%;background:radial-gradient(circle,rgba(239,52,118,.32),transparent 60%);transform:translate(-50%,-50%);filter:blur(20px);transition:left .35s ease,top .35s ease}
.tabela-root .hero-glyphs{position:absolute;inset:0;pointer-events:none;z-index:0;overflow:hidden}
.tabela-root .gly{position:absolute;font-family:var(--tmono);font-size:14px;color:rgba(239,52,118,.35);font-weight:600;animation:tabFloat 14s ease-in-out infinite;letter-spacing:.1em}
.tabela-root .gly.lg{font-size:24px;color:rgba(255,255,255,.08)}
.tabela-root .gly.xl{font-size:42px;color:rgba(255,255,255,.05)}
@keyframes tabFloat{0%,100%{transform:translateY(0) rotate(0deg)}50%{transform:translateY(-22px) rotate(8deg)}}
.tabela-root .gly-plus{position:absolute;width:18px;height:18px;color:rgba(239,52,118,.45);animation:tabFloat 16s ease-in-out infinite}
.tabela-root .gly-plus::before,.tabela-root .gly-plus::after{content:"";position:absolute;background:currentColor;border-radius:1px}
.tabela-root .gly-plus::before{left:50%;top:0;width:2px;height:100%;transform:translateX(-50%)}
.tabela-root .gly-plus::after{top:50%;left:0;height:2px;width:100%;transform:translateY(-50%)}
.tabela-root .gly-plus.white{color:rgba(255,255,255,.18)}
.tabela-root .hero-inner{position:relative;text-align:center;z-index:1}
.tabela-root .hero .kicker{display:inline-flex;align-items:center;gap:10px;font-family:var(--tmono);font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:rgba(255,255,255,.7);font-weight:500;margin-bottom:24px}
.tabela-root .hero .kicker .plus::before,.tabela-root .hero .kicker .plus::after{background:var(--rose-2)}
.tabela-root .hero h1{color:#fff;max-width:880px;margin:0 auto}
.tabela-root .hero-lede{max-width:620px;margin:24px auto 0;color:rgba(255,255,255,.72);font-size:17px;line-height:1.55}
.tabela-root .hero-pills{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:36px auto 0;max-width:780px}
.tabela-root .hero .pill-light{font-size:12px;padding:7px 14px}
.tabela-root .hero-stats{display:flex;gap:28px;justify-content:center;margin-top:48px;flex-wrap:wrap;position:relative;z-index:1}
.tabela-root .hero-stat{display:flex;flex-direction:column;align-items:center;gap:4px;padding:0 24px;border-left:1px solid rgba(255,255,255,.12)}
.tabela-root .hero-stat:first-child{border-left:0}
.tabela-root .hero-stat .num{font-family:var(--tdisplay);font-size:28px;font-weight:700;letter-spacing:-0.025em;color:#fff;line-height:1}
.tabela-root .hero-stat .num .t-grad-text{font-size:inherit}
.tabela-root .hero-stat .lbl{font-family:var(--tmono);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:rgba(255,255,255,.55);font-weight:600}
.tabela-root .live-dot{display:inline-block;width:7px;height:7px;border-radius:50%;background:#1FB870;margin-right:6px;box-shadow:0 0 0 0 rgba(31,184,112,.6);animation:tabPulse 2s infinite}
@keyframes tabPulse{0%{box-shadow:0 0 0 0 rgba(31,184,112,.6)}70%{box-shadow:0 0 0 10px rgba(31,184,112,0)}100%{box-shadow:0 0 0 0 rgba(31,184,112,0)}}

/* MARQUEE */
.tabela-root .marquee{position:relative;background:var(--ink-0);color:#fff;padding:18px 0;overflow:hidden;border-top:1px solid rgba(255,255,255,.06);border-bottom:1px solid rgba(255,255,255,.06)}
.tabela-root .marquee-track{display:flex;gap:48px;width:max-content;animation:tabMarq 40s linear infinite}
.tabela-root .marquee:hover .marquee-track{animation-play-state:paused}
.tabela-root .marquee-item{display:inline-flex;align-items:center;gap:14px;font-family:var(--tmono);font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:rgba(255,255,255,.7);font-weight:500;white-space:nowrap}
.tabela-root .marquee-item .plus{color:var(--rose-2)}
.tabela-root .marquee-item b{color:#fff;font-weight:600}
@keyframes tabMarq{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}

/* Scroll progress */
.tabela-root .scroll-progress{position:fixed;top:0;left:0;height:3px;width:0;background:var(--grad);z-index:50;transition:width .1s linear}

/* JORNADA */
.tabela-root .journey-wrap{position:relative}
.tabela-root .journey{display:grid;grid-template-columns:repeat(5,1fr);gap:14px;position:relative}
.tabela-root .journey::before{content:"";position:absolute;left:6%;right:6%;top:64px;height:1px;background:linear-gradient(90deg,transparent,var(--ink-7) 12%,var(--ink-7) 88%,transparent);z-index:0}
.tabela-root .step{position:relative;background:var(--white);border:1px solid var(--line);border-radius:var(--r);padding:20px 18px;display:flex;flex-direction:column;gap:10px;z-index:1;box-shadow:var(--shadow-soft)}
.tabela-root .step.active{border-color:rgba(239,52,118,.35);box-shadow:0 0 0 4px rgba(239,52,118,.08),var(--shadow-soft)}
.tabela-root .step-num{display:inline-flex;align-items:center;gap:8px;font-family:var(--tmono);font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:var(--ink-4);font-weight:600}
.tabela-root .step-dot{width:10px;height:10px;border-radius:50%;background:var(--ink-7);position:relative;flex:none}
.tabela-root .step.active .step-dot{background:var(--grad);box-shadow:0 0 0 4px rgba(239,52,118,.16)}
.tabela-root .step.done .step-dot{background:var(--rose-1)}
.tabela-root .step h4{font-family:var(--tdisplay);font-size:18px;letter-spacing:-0.015em;font-weight:700;color:var(--ink-0)}
.tabela-root .step .step-price{font-family:var(--tmono);font-size:11px;color:var(--rose-1);font-weight:600;letter-spacing:.04em}
.tabela-root .step .step-desc{font-size:13px;color:var(--ink-3);line-height:1.5}
.tabela-root .you-here{margin-top:32px;display:flex;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap}
.tabela-root .you-here-pill{display:inline-flex;align-items:center;gap:10px;background:var(--white);border:1px solid var(--line);padding:8px 16px;border-radius:999px;box-shadow:var(--shadow-soft)}
.tabela-root .you-here-pill .plus{width:10px;height:10px}
.tabela-root .you-here-pill b{color:var(--ink-0);font-weight:600;font-size:13px}
.tabela-root .you-here-note{font-size:13px;color:var(--ink-4)}

/* DOSSIE */
.tabela-root .dossier{display:flex;flex-direction:column;gap:16px}
.tabela-root .dcard{background:var(--white);border:1px solid var(--line);border-radius:var(--r-lg);padding:32px;display:grid;grid-template-columns:280px 1fr;gap:32px;box-shadow:var(--shadow-soft);position:relative;overflow:hidden}
.tabela-root .dcard.featured{border-color:rgba(239,52,118,.25);box-shadow:0 0 0 5px rgba(239,52,118,.05),var(--shadow-soft)}
.tabela-root .dcard-head{display:flex;flex-direction:column;gap:10px}
.tabela-root .dcard-head .pill{align-self:flex-start}
.tabela-root .dcard-head h3{font-size:24px;font-weight:700;letter-spacing:-0.02em}
.tabela-root .dcard-price{display:flex;flex-direction:column;gap:2px;margin-top:4px}
.tabela-root .dcard-price .v{font-family:var(--tdisplay);font-size:22px;font-weight:700;color:var(--ink-0);letter-spacing:-0.02em}
.tabela-root .dcard-price .v.gratis{color:var(--ok)}
.tabela-root .dcard-price .sub{font-family:var(--tmono);font-size:10px;letter-spacing:.12em;color:var(--ink-4);text-transform:uppercase}
.tabela-root .dcard-body{display:flex;flex-direction:column;gap:18px}
.tabela-root .dcard-body p{color:var(--ink-2);font-size:14.5px;line-height:1.6}
.tabela-root .dcard-body p strong{color:var(--ink-0);font-weight:700}
.tabela-root .dcard-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-top:4px}
.tabela-root .dcard-grid .cell{background:var(--paper-2);border:1px solid var(--line-2);border-radius:var(--r-sm);padding:14px}
.tabela-root .dcard.featured .dcard-grid .cell{background:rgba(239,52,118,.04);border-color:rgba(239,52,118,.15)}
.tabela-root .dcard-grid .cell .lbl{font-family:var(--tmono);font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:var(--rose-1);font-weight:600;margin-bottom:6px}
.tabela-root .dcard-grid .cell .txt{font-size:12.5px;color:var(--ink-2);line-height:1.45}
.tabela-root .dcard-tags{display:flex;flex-wrap:wrap;gap:8px}
.tabela-root .dcard-tags .pill{font-size:11.5px;padding:5px 11px;background:var(--paper);border-color:var(--line)}

/* DARK CTA */
.tabela-root .dark-cta{position:relative;background:var(--ink-0);color:#fff;border-radius:var(--r-xl);padding:64px 56px;overflow:hidden;text-align:center}
.tabela-root .dark-cta::before{content:"";position:absolute;inset:0;opacity:.5;background-image:linear-gradient(rgba(255,255,255,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.05) 1px,transparent 1px);background-size:36px 36px}
.tabela-root .dark-cta::after{content:"";position:absolute;left:50%;top:-40%;width:520px;height:520px;border-radius:50%;background:radial-gradient(circle,rgba(239,52,118,.28),transparent 60%);transform:translateX(-50%);filter:blur(10px);pointer-events:none}
.tabela-root .dark-cta-inner{position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;gap:18px}
.tabela-root .dark-cta .kicker{font-family:var(--tmono);font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:var(--rose-2);font-weight:600;display:inline-flex;gap:10px;align-items:center}
.tabela-root .dark-cta .kicker .plus::before,.tabela-root .dark-cta .kicker .plus::after{background:var(--rose-2)}
.tabela-root .dark-cta h2{color:#fff;max-width:760px}
.tabela-root .dark-cta p{color:rgba(255,255,255,.7);max-width:600px;margin:0 auto;font-size:15px}
.tabela-root .dark-cta-actions{display:flex;gap:10px;flex-wrap:wrap;justify-content:center;margin-top:14px}

/* FORK */
.tabela-root .fork{display:grid;grid-template-columns:1fr 1fr;gap:18px}
.tabela-root .fork-card{background:var(--white);border:1px solid var(--line);border-radius:var(--r-lg);padding:32px;display:flex;flex-direction:column;gap:18px;position:relative}
.tabela-root .fork-card.featured{background:linear-gradient(180deg,#fff,#fffafc);border-color:rgba(239,52,118,.22);box-shadow:0 0 0 4px rgba(239,52,118,.06),var(--shadow-soft)}
.tabela-root .fork-head{display:flex;justify-content:space-between;align-items:flex-start;gap:14px}
.tabela-root .fork-head .label{display:flex;flex-direction:column;gap:6px}
.tabela-root .fork-card h3{font-size:24px;font-weight:700;letter-spacing:-0.02em}
.tabela-root .fork-card .summary{font-size:14px;color:var(--ink-3);line-height:1.55}
.tabela-root .fork-rows{display:flex;flex-direction:column;gap:8px}
.tabela-root .fork-row{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;padding:14px 16px;background:var(--paper-2);border:1px solid var(--line-2);border-radius:var(--r-sm)}
.tabela-root .fork-card.featured .fork-row{background:rgba(239,52,118,.035);border-color:rgba(239,52,118,.14)}
.tabela-root .fork-row .name{font-family:var(--tdisplay);font-weight:700;font-size:14.5px;color:var(--ink-0);letter-spacing:-0.01em}
.tabela-root .fork-row .desc{font-size:12.5px;color:var(--ink-3);line-height:1.45;margin-top:2px}
.tabela-root .fork-row .price{font-family:var(--tdisplay);font-weight:700;font-size:16px;color:var(--ink-0);letter-spacing:-0.015em;flex:none}
.tabela-root .fork-foot{font-size:12.5px;color:var(--ink-4);font-style:italic;margin-top:auto}

/* PACOTES */
.tabela-root .packs{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;align-items:stretch}
.tabela-root .pack{position:relative;background:var(--white);border:1px solid var(--line);border-radius:var(--r-lg);padding:32px 28px;display:flex;flex-direction:column;gap:20px;box-shadow:var(--shadow-soft);transition:transform .25s cubic-bezier(.2,.7,.2,1),box-shadow .25s ease}
.tabela-root .pack:hover{transform:translateY(-3px);box-shadow:var(--shadow-card)}
.tabela-root .pack:hover .pack-price .v{transform:scale(1.04)}
.tabela-root .pack-popular{transform:translateY(-12px);border-color:transparent;background:linear-gradient(180deg,#fff,#fff5f8);box-shadow:0 0 0 2px var(--rose-1),0 22px 40px -16px rgba(239,52,118,.28)}
.tabela-root .pack-popular:hover{transform:translateY(-15px)}
.tabela-root .pack-badge{position:absolute;top:-13px;left:50%;transform:translateX(-50%);background:var(--grad);color:#fff;font-family:var(--tmono);font-size:10px;letter-spacing:.18em;text-transform:uppercase;font-weight:700;padding:6px 14px;border-radius:999px;box-shadow:var(--shadow-glow)}
.tabela-root .pack-head{display:flex;flex-direction:column;gap:6px}
.tabela-root .pack-head .pill{align-self:flex-start}
.tabela-root .pack h3{font-family:var(--tdisplay);font-size:26px;letter-spacing:-0.02em;font-weight:700;color:var(--ink-0);margin-top:6px}
.tabela-root .pack-price{display:flex;align-items:baseline;gap:10px;margin-top:10px}
.tabela-root .pack-price .v{font-family:var(--tdisplay);font-size:42px;font-weight:800;letter-spacing:-0.03em;color:var(--ink-0);line-height:1;display:inline-block;transition:transform .25s ease;transform-origin:left center}
.tabela-root .pack-popular .pack-price .v{background:var(--grad);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent}
.tabela-root .pack-saving{display:inline-flex;align-items:center;gap:6px;font-family:var(--tmono);font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--ok);font-weight:600;margin-top:2px}
.tabela-root .pack-features{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:10px;border-top:1px solid var(--line);padding-top:20px}
.tabela-root .pack-features li{display:flex;align-items:flex-start;gap:10px;font-size:13.5px;color:var(--ink-2);line-height:1.45}
.tabela-root .pack-features li svg{flex:none;margin-top:1px;color:var(--rose-1)}
.tabela-root .pack-meta{display:flex;flex-direction:column;gap:6px;margin-top:auto;padding-top:16px;border-top:1px dashed var(--line)}
.tabela-root .pack-meta .row{display:flex;align-items:center;justify-content:space-between;font-size:12.5px}
.tabela-root .pack-meta .row .lbl{font-family:var(--tmono);font-size:10px;letter-spacing:.14em;color:var(--ink-4);text-transform:uppercase;font-weight:600}
.tabela-root .pack-meta .row .val{color:var(--ink-1);font-weight:600;text-align:right;max-width:60%}
.tabela-root .pack .t-btn{margin-top:6px;width:100%}
.tabela-root .pack-fineprint{margin-top:28px;padding:20px 24px;background:var(--white);border:1px dashed var(--line);border-radius:var(--r);font-size:13px;color:var(--ink-3);line-height:1.6}
.tabela-root .pack-fineprint strong{color:var(--ink-1);font-weight:600}

/* MATRIX */
.tabela-root .matrix{margin-top:48px;background:var(--white);border:1px solid var(--line);border-radius:var(--r-lg);overflow:hidden;box-shadow:var(--shadow-soft)}
.tabela-root .matrix[hidden]{display:none}
.tabela-root .matrix table{width:100%;border-collapse:collapse}
.tabela-root .matrix th,.tabela-root .matrix td{padding:14px 18px;text-align:left;font-size:13.5px;border-bottom:1px solid var(--line-2);vertical-align:middle}
.tabela-root .matrix th{background:var(--paper-2);font-family:var(--tmono);font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-3);font-weight:600;border-bottom:1px solid var(--line)}
.tabela-root .matrix th.col-pop{background:linear-gradient(180deg,rgba(239,52,118,.08),rgba(239,52,118,.02));color:var(--rose-1)}
.tabela-root .matrix td.feat{font-weight:600;color:var(--ink-1);font-family:var(--ttext)}
.tabela-root .matrix td.col-pop{background:rgba(239,52,118,.025)}
.tabela-root .matrix td.center{text-align:center}
.tabela-root .matrix .check{color:var(--ok)}
.tabela-root .matrix .dash{color:var(--ink-5)}
.tabela-root .matrix tr:last-child td{border-bottom:0}
.tabela-root .matrix tr.row-price td{background:var(--paper-2);font-family:var(--tdisplay);font-size:22px;font-weight:800;letter-spacing:-0.02em;color:var(--ink-0);padding:18px}
.tabela-root .matrix tr.row-price td.col-pop{background:linear-gradient(180deg,rgba(239,52,118,.08),rgba(239,52,118,.04));background-clip:text;-webkit-background-clip:text;color:transparent;-webkit-text-fill-color:transparent;background-image:var(--grad)}
.tabela-root .matrix-toggle{display:flex;justify-content:center;margin-top:32px}

/* ATIVOS */
.tabela-root .assets-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px}
.tabela-root .asset{background:var(--white);border:1px solid var(--line);border-radius:var(--r);padding:20px;display:flex;flex-direction:column;gap:10px;transition:border-color .15s ease,transform .15s ease,box-shadow .15s ease;cursor:default;position:relative;overflow:hidden}
.tabela-root .asset:hover{border-color:var(--ink-6);transform:translateY(-2px);box-shadow:var(--shadow-soft)}
.tabela-root .asset::after{content:"";position:absolute;left:-50%;top:-50%;width:80px;height:300%;background:linear-gradient(90deg,transparent,rgba(239,52,118,.12),transparent);transform:translateX(-200%) rotate(20deg);transition:transform .8s ease;pointer-events:none}
.tabela-root .asset:hover::after{transform:translateX(800%) rotate(20deg)}
.tabela-root .asset-head{display:flex;align-items:center;justify-content:space-between;gap:10px}
.tabela-root .asset-icon{width:32px;height:32px;border-radius:8px;background:rgba(239,52,118,.08);color:var(--rose-1);display:flex;align-items:center;justify-content:center;flex:none}
.tabela-root .asset .price{font-family:var(--tmono);font-size:13px;letter-spacing:.02em;color:var(--ink-0);font-weight:600}
.tabela-root .asset h4{font-family:var(--tdisplay);font-weight:700;font-size:16px;letter-spacing:-0.015em;color:var(--ink-0)}
.tabela-root .asset .desc{font-size:12.5px;color:var(--ink-3);line-height:1.5}
.tabela-root .asset .prazo{font-family:var(--tmono);font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--ink-4);margin-top:auto;padding-top:8px;border-top:1px dashed var(--line-2);font-weight:500}
.tabela-root .asset.dashed{background:var(--paper-2);border-style:dashed}
.tabela-root .asset.dashed .asset-icon{background:rgba(10,10,11,.05);color:var(--ink-2)}
.tabela-root .asset.dashed .price{color:var(--ink-3)}
.tabela-root .asset.dashed h4{color:var(--ink-2)}

/* ARTIGOS */
.tabela-root .articles{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;max-width:760px;margin:0 auto}
.tabela-root .article-pack{background:var(--white);border:1px solid var(--line);border-radius:var(--r);padding:22px 20px;text-align:center;display:flex;flex-direction:column;gap:6px}
.tabela-root .article-pack .qty{font-family:var(--tdisplay);font-size:14px;font-weight:600;color:var(--ink-2);letter-spacing:-0.01em}
.tabela-root .article-pack .price{font-family:var(--tdisplay);font-size:30px;font-weight:800;letter-spacing:-0.025em;color:var(--ink-0);margin-top:4px}
.tabela-root .article-pack .unit{font-family:var(--tmono);font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:var(--rose-1);font-weight:600;margin-top:4px}
.tabela-root .article-pack.best{border-color:rgba(239,52,118,.25);background:linear-gradient(180deg,#fff,#fff5f8)}

/* ISCAS */
.tabela-root .iscas-disclaimer{margin:0 auto 32px;max-width:680px;text-align:center;font-size:13px;color:var(--ink-4);font-style:italic}
.tabela-root .iscas-cat{margin-bottom:36px}
.tabela-root .iscas-cat:last-child{margin-bottom:0}
.tabela-root .iscas-cat-head{display:flex;align-items:flex-end;justify-content:space-between;gap:12px;margin-bottom:14px;padding-bottom:12px;border-bottom:1px solid var(--line)}
.tabela-root .iscas-cat-head .left{display:flex;align-items:center;gap:10px}
.tabela-root .iscas-cat-head h3{font-family:var(--tdisplay);font-size:18px;font-weight:700;letter-spacing:-0.015em;color:var(--ink-0)}
.tabela-root .iscas-cat-head .sub{font-family:var(--tmono);font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-4);font-weight:500}
.tabela-root .cat-mark{width:8px;height:8px;border-radius:50%;flex:none}
.tabela-root .cat-conv{background:var(--rose-1)}
.tabela-root .cat-qual{background:#5e6ad2}
.tabela-root .cat-pos{background:var(--ok)}
.tabela-root .iscas-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
.tabela-root .isca{background:var(--white);border:1px solid var(--line);border-radius:var(--r-sm);padding:16px 16px 14px;display:flex;flex-direction:column;gap:6px;cursor:pointer;transition:border-color .15s,transform .15s,box-shadow .15s;text-decoration:none;color:inherit;scroll-margin-top:96px}
.tabela-root .isca:hover{border-color:var(--ink-6);transform:translateY(-1px);box-shadow:var(--shadow-soft)}
.tabela-root .isca-row{display:flex;align-items:flex-start;justify-content:space-between;gap:10px}
.tabela-root .isca h4{font-family:var(--tdisplay);font-size:14.5px;font-weight:700;letter-spacing:-0.01em;color:var(--ink-0)}
.tabela-root .isca .price{font-family:var(--tmono);font-size:12px;color:var(--ink-0);font-weight:600;flex:none}
.tabela-root .isca .desc{font-size:12px;color:var(--ink-3);line-height:1.45}
.tabela-root .isca .more{font-family:var(--tmono);font-size:9px;letter-spacing:.14em;text-transform:uppercase;color:var(--rose-1);font-weight:600;margin-top:4px}

/* FUNIS */
.tabela-root .funis{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
.tabela-root .funil{background:var(--white);border:1px solid var(--line);border-radius:var(--r-lg);padding:28px;display:flex;flex-direction:column;gap:12px;position:relative;overflow:hidden}
.tabela-root .funil.featured{border-color:rgba(239,52,118,.22);background:linear-gradient(180deg,#fff,#fff5f8)}
.tabela-root .funil .pill{align-self:flex-start}
.tabela-root .funil h3{font-family:var(--tdisplay);font-size:22px;font-weight:700;letter-spacing:-0.02em;color:var(--ink-0)}
.tabela-root .funil .price{font-family:var(--tdisplay);font-size:30px;font-weight:800;letter-spacing:-0.025em;color:var(--ink-0)}
.tabela-root .funil .desc{font-size:13.5px;color:var(--ink-3);line-height:1.55}
.tabela-root .funil-flow{display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-top:8px;padding-top:14px;border-top:1px dashed var(--line)}
.tabela-root .funil-flow .step-pill{font-family:var(--tmono);font-size:9.5px;letter-spacing:.1em;text-transform:uppercase;background:var(--paper-2);border:1px solid var(--line-2);padding:4px 8px;border-radius:6px;color:var(--ink-2);font-weight:600}
.tabela-root .funil-flow svg{color:var(--ink-5);flex:none}
.tabela-root .funil-svg{margin-top:14px;padding-top:14px;border-top:1px dashed var(--line)}
.tabela-root .funil-svg svg{width:100%;height:auto;max-height:120px;display:block}

/* COMUNIDADE */
.tabela-root .community{background:var(--white);border:1px solid var(--line);border-radius:var(--r-xl);padding:48px 56px;display:grid;grid-template-columns:1.2fr 1fr;gap:40px;align-items:center;box-shadow:var(--shadow-soft);position:relative;overflow:hidden}
.tabela-root .community::before{content:"";position:absolute;right:-80px;top:-80px;width:340px;height:340px;border-radius:50%;background:radial-gradient(circle,rgba(239,52,118,.10),transparent 65%);pointer-events:none}
.tabela-root .community-left{display:flex;flex-direction:column;gap:14px;position:relative}
.tabela-root .community-left .kicker{font-family:var(--tmono);font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:var(--rose-1);font-weight:600;display:inline-flex;align-items:center;gap:10px}
.tabela-root .community-left h2{font-size:34px;font-weight:700;letter-spacing:-0.025em;color:var(--ink-0)}
.tabela-root .community-left p{font-size:15px;color:var(--ink-3);line-height:1.55}
.tabela-root .community-right{display:flex;flex-direction:column;gap:14px;align-items:flex-start;position:relative}
.tabela-root .community-price{font-family:var(--tdisplay);font-size:48px;font-weight:800;letter-spacing:-0.03em;background:var(--grad);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent;line-height:1}
.tabela-root .community-price small{display:block;font-family:var(--tmono);font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-4);background:none;-webkit-text-fill-color:var(--ink-4);font-weight:600;margin-top:6px}
.tabela-root .community-bullets{display:flex;flex-direction:column;gap:10px;list-style:none;padding:0;margin:0}
.tabela-root .community-bullets li{display:flex;align-items:flex-start;gap:10px;font-size:13.5px;color:var(--ink-2);line-height:1.45}
.tabela-root .community-bullets li svg{color:var(--rose-1);flex:none;margin-top:1px}

/* RULES */
.tabela-root .rules{position:relative;background:var(--ink-0);color:#fff;border-radius:var(--r-xl);padding:48px 56px;overflow:hidden}
.tabela-root .rules::before{content:"";position:absolute;inset:0;opacity:.35;background-image:linear-gradient(rgba(255,255,255,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.05) 1px,transparent 1px);background-size:36px 36px}
.tabela-root .rules-inner{position:relative;z-index:1}
.tabela-root .rules-head{display:flex;align-items:center;gap:14px;margin-bottom:14px}
.tabela-root .rules-head .kicker{font-family:var(--tmono);font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:var(--rose-2);font-weight:600;display:inline-flex;gap:10px;align-items:center}
.tabela-root .rules h2{color:#fff;font-size:30px;font-weight:700;letter-spacing:-0.025em;margin-bottom:28px}
.tabela-root .rules-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px 32px;list-style:none;padding:0;margin:0}
.tabela-root .rules-grid li{display:flex;align-items:flex-start;gap:12px;font-size:14px;color:rgba(255,255,255,.82);line-height:1.5;padding:6px 0}
.tabela-root .rules-grid li .plus{margin-top:6px}

/* OPS */
.tabela-root .ops{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-bottom:32px}
.tabela-root .op-card{background:var(--white);border:1px solid var(--line);border-radius:var(--r);padding:24px;display:flex;flex-direction:column;gap:8px}
.tabela-root .op-icon{width:36px;height:36px;border-radius:9px;background:rgba(239,52,118,.08);color:var(--rose-1);display:flex;align-items:center;justify-content:center;margin-bottom:6px}
.tabela-root .op-card h4{font-family:var(--tdisplay);font-size:17px;font-weight:700;letter-spacing:-0.015em;color:var(--ink-0)}
.tabela-root .op-card p{font-size:13.5px;color:var(--ink-3);line-height:1.55}
.tabela-root .notdo{background:var(--paper-2);border:1px solid var(--line-2);border-radius:var(--r);padding:24px 28px}
.tabela-root .notdo-head{display:flex;align-items:center;gap:10px;margin-bottom:14px}
.tabela-root .notdo-head .kicker{font-family:var(--tmono);font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:var(--ink-4);font-weight:600}
.tabela-root .notdo ul{list-style:none;padding:0;margin:0;display:grid;grid-template-columns:1fr 1fr;gap:10px 28px}
.tabela-root .notdo li{display:flex;align-items:flex-start;gap:10px;font-size:13.5px;color:var(--ink-3);line-height:1.5}
.tabela-root .notdo li::before{content:"·";color:var(--ink-5);font-weight:700;font-size:18px;margin-top:-3px;flex:none}

/* CALC */
.tabela-root .calc{background:var(--white);border:1px solid var(--line);border-radius:var(--r-xl);padding:40px;display:grid;grid-template-columns:1.4fr 1fr;gap:32px;box-shadow:var(--shadow-soft);position:relative;overflow:hidden}
.tabela-root .calc::before{content:"";position:absolute;right:-100px;bottom:-100px;width:340px;height:340px;border-radius:50%;background:radial-gradient(circle,rgba(239,52,118,.08),transparent 65%);pointer-events:none}
.tabela-root .calc-left{position:relative}
.tabela-root .calc-section{margin-bottom:24px}
.tabela-root .calc-section .lbl{font-family:var(--tmono);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--rose-1);font-weight:600;margin-bottom:10px;display:block}
.tabela-root .calc-options{display:flex;flex-wrap:wrap;gap:8px}
.tabela-root .calc-opt{display:inline-flex;align-items:center;gap:8px;padding:10px 14px;border:1px solid var(--line);background:var(--white);border-radius:999px;cursor:pointer;font-size:13px;font-weight:500;color:var(--ink-2);transition:all .15s ease;font-family:var(--ttext);user-select:none}
.tabela-root .calc-opt:hover{border-color:var(--ink-5)}
.tabela-root .calc-opt.on{background:var(--ink-0);color:#fff;border-color:var(--ink-0)}
.tabela-root .calc-opt.on .calc-opt-price{color:rgba(255,255,255,.7)}
.tabela-root .calc-opt-price{font-family:var(--tmono);font-size:11px;color:var(--ink-4);font-weight:600}
.tabela-root .calc-right{position:relative;background:var(--ink-0);color:#fff;border-radius:var(--r-lg);padding:32px;display:flex;flex-direction:column;justify-content:space-between;overflow:hidden}
.tabela-root .calc-right::before{content:"";position:absolute;inset:0;opacity:.4;background-image:linear-gradient(rgba(255,255,255,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.06) 1px,transparent 1px);background-size:32px 32px;-webkit-mask-image:radial-gradient(circle at 70% 30%,#000 30%,transparent 75%);mask-image:radial-gradient(circle at 70% 30%,#000 30%,transparent 75%)}
.tabela-root .calc-right-inner{position:relative;z-index:1;display:flex;flex-direction:column;gap:18px;height:100%}
.tabela-root .calc-summary{flex:1;display:flex;flex-direction:column;gap:8px}
.tabela-root .calc-summary-row{display:flex;justify-content:space-between;font-size:13px;color:rgba(255,255,255,.7);padding:6px 0;border-bottom:1px dashed rgba(255,255,255,.1)}
.tabela-root .calc-summary-row b{color:#fff;font-weight:500}
.tabela-root .calc-empty{color:rgba(255,255,255,.5);font-size:13px;font-style:italic}
.tabela-root .calc-total-block{padding-top:18px;border-top:1px solid rgba(255,255,255,.18)}
.tabela-root .calc-total-lbl{font-family:var(--tmono);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:rgba(255,255,255,.55);font-weight:600}
.tabela-root .calc-total{font-family:var(--tdisplay);font-size:42px;font-weight:800;letter-spacing:-0.03em;background:var(--grad);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent;line-height:1;margin-top:6px}
.tabela-root .calc-hint{font-size:12px;color:rgba(255,255,255,.5);margin-top:8px;line-height:1.5}

/* FAQ */
.tabela-root .faq{display:flex;flex-direction:column;gap:10px;max-width:880px;margin:0 auto}
.tabela-root .faq-item{background:var(--white);border:1px solid var(--line);border-radius:var(--r);overflow:hidden;transition:border-color .15s ease,box-shadow .15s ease}
.tabela-root .faq-item.open{border-color:var(--ink-6);box-shadow:var(--shadow-soft)}
.tabela-root .faq-q{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:20px 24px;cursor:pointer;font-family:var(--tdisplay);font-size:16px;font-weight:600;letter-spacing:-0.01em;color:var(--ink-0);user-select:none}
.tabela-root .faq-q:hover{background:var(--paper-2)}
.tabela-root .faq-icon{width:24px;height:24px;border-radius:6px;background:var(--paper-2);display:flex;align-items:center;justify-content:center;color:var(--ink-3);transition:transform .25s ease,background .15s,color .15s;flex:none}
.tabela-root .faq-item.open .faq-icon{background:var(--rose-1);color:#fff;transform:rotate(45deg)}
.tabela-root .faq-a{max-height:0;overflow:hidden;transition:max-height .35s cubic-bezier(.2,.7,.2,1);padding:0 24px;color:var(--ink-3);font-size:14px;line-height:1.6}
.tabela-root .faq-item.open .faq-a{max-height:280px;padding-bottom:22px}

/* FINAL CTA */
.tabela-root .final-cta{position:relative;background:var(--grad);color:#fff;border-radius:var(--r-xl);padding:72px 56px;overflow:hidden;text-align:center}
.tabela-root .final-cta::before{content:"";position:absolute;inset:0;opacity:.4;background-image:linear-gradient(rgba(255,255,255,.18) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.18) 1px,transparent 1px);background-size:36px 36px;-webkit-mask-image:radial-gradient(ellipse at center,#000 30%,transparent 75%);mask-image:radial-gradient(ellipse at center,#000 30%,transparent 75%)}
.tabela-root .final-cta-inner{position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;gap:16px}
.tabela-root .final-cta .kicker{display:inline-flex;align-items:center;gap:10px;font-family:var(--tmono);font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:rgba(255,255,255,.85);font-weight:600}
.tabela-root .final-cta .kicker .plus::before,.tabela-root .final-cta .kicker .plus::after{background:#fff}
.tabela-root .final-cta h2{color:#fff;max-width:780px}
.tabela-root .final-cta p{color:rgba(255,255,255,.86);max-width:580px;margin:0 auto;font-size:15.5px}
.tabela-root .final-cta-actions{display:flex;gap:10px;flex-wrap:wrap;justify-content:center;margin-top:14px}
.tabela-root .final-cta .t-btn-ghost-light{background:rgba(0,0,0,.16);border-color:rgba(255,255,255,.32)}
.tabela-root .final-cta-white{background:#fff;color:var(--ink-0)}

/* FOOTER */
.tabela-root .foot{padding:32px 0 64px;text-align:center;font-family:var(--tmono);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--ink-4);font-weight:500}
.tabela-root .foot .sep{margin:0 12px;color:var(--ink-6)}

/* RESPONSIVE */
@media (max-width:1100px){
  .tabela-root .journey{grid-template-columns:repeat(3,1fr)}
  .tabela-root .journey::before{display:none}
  .tabela-root .packs{grid-template-columns:1fr;gap:14px}
  .tabela-root .pack-popular{transform:none}
  .tabela-root .pack-popular:hover{transform:translateY(-3px)}
  .tabela-root .assets-grid,.tabela-root .iscas-grid,.tabela-root .funis,.tabela-root .ops{grid-template-columns:repeat(2,1fr)}
  .tabela-root .dcard{grid-template-columns:1fr;gap:24px}
  .tabela-root .dcard-grid{grid-template-columns:1fr 1fr}
  .tabela-root .fork{grid-template-columns:1fr}
  .tabela-root .community{grid-template-columns:1fr;padding:36px}
  .tabela-root .rules-grid,.tabela-root .notdo ul{grid-template-columns:1fr}
  .tabela-root .calc{grid-template-columns:1fr;padding:32px}
}

/* ═══ MOBILE-FIRST OTIMIZADO (≤ 680px) ═══ */
@media (max-width:680px){
  /* Sections compactas */
  .tabela-root .t-section{padding:48px 0}
  .tabela-root .t-section-head{margin-bottom:32px;gap:10px}
  .tabela-root .t-shell,.tabela-root .t-shell-narrow{padding:0 18px}
  .tabela-root h1{font-size:clamp(28px,7vw,40px);letter-spacing:-0.025em}
  .tabela-root h2{font-size:clamp(22px,5.6vw,30px)}
  .tabela-root h3{font-size:18px}
  .tabela-root h4{font-size:15.5px}

  /* Top nav */
  .tabela-root .topnav-inner{padding:11px 16px;gap:10px}
  .tabela-root .topnav-links{display:none}
  .tabela-root .brand-mark{width:26px;height:26px}
  .tabela-root .brand-text{font-size:13.5px}
  .tabela-root .brand-text small{display:none}
  .tabela-root .t-btn-sm{padding:8px 12px;font-size:12px}

  /* HERO compacto */
  .tabela-root .hero{padding:64px 0 56px}
  .tabela-root .hero-glyphs{display:none}
  .tabela-root .hero-mesh::before{width:600px;height:600px;filter:blur(40px)}
  .tabela-root .hero-lede{font-size:14.5px;margin-top:18px}
  .tabela-root .hero-pills{margin-top:24px;gap:6px;justify-content:center}
  .tabela-root .hero .pill-light{font-size:10.5px;padding:5px 10px;letter-spacing:.1em}
  .tabela-root .hero .kicker{font-size:10px;margin-bottom:18px;letter-spacing:.14em}

  /* Hero stats: 2×2 grid com bordas internas */
  .tabela-root .hero-stats{margin-top:32px;display:grid;grid-template-columns:1fr 1fr;gap:0;width:100%;border-top:1px solid rgba(255,255,255,.1);border-bottom:1px solid rgba(255,255,255,.1)}
  .tabela-root .hero-stat{padding:14px 12px;border-left:0;border-right:1px solid rgba(255,255,255,.06);border-bottom:1px solid rgba(255,255,255,.06);align-items:flex-start;gap:6px}
  .tabela-root .hero-stat:nth-child(2n){border-right:0}
  .tabela-root .hero-stat:nth-child(n+3){border-bottom:0}
  .tabela-root .hero-stat .num{font-size:22px}
  .tabela-root .hero-stat .lbl{font-size:9px;text-align:left;letter-spacing:.12em}

  /* Marquee tighter */
  .tabela-root .marquee{padding:14px 0}
  .tabela-root .marquee-track{gap:32px}
  .tabela-root .marquee-item{font-size:11px;letter-spacing:.12em;gap:10px}

  /* Jornada: scroll horizontal pra ler todas as etapas */
  .tabela-root .journey{display:flex;grid-template-columns:none;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;margin:0 -18px;padding:4px 18px 14px;scrollbar-width:none}
  .tabela-root .journey::-webkit-scrollbar{display:none}
  .tabela-root .journey .step{min-width:230px;scroll-snap-align:start;padding:16px}
  .tabela-root .step h4{font-size:15.5px}
  .tabela-root .step .step-desc{font-size:12.5px}
  .tabela-root .you-here{flex-direction:column;gap:8px;text-align:center;margin-top:18px}
  .tabela-root .you-here-pill{font-size:11.5px;padding:7px 12px}

  /* Dossier */
  .tabela-root .dcard{padding:22px;gap:18px;border-radius:var(--r)}
  .tabela-root .dcard-head{gap:8px}
  .tabela-root .dcard-head h3{font-size:21px}
  .tabela-root .dcard-price .v{font-size:20px}
  .tabela-root .dcard-grid{grid-template-columns:1fr;gap:10px}
  .tabela-root .dcard-grid .cell{padding:12px}
  .tabela-root .dcard-tags .pill{font-size:10.5px;padding:4px 9px}

  /* Dark CTA */
  .tabela-root .dark-cta{padding:32px 22px;border-radius:var(--r-lg)}
  .tabela-root .dark-cta h2{font-size:24px}
  .tabela-root .dark-cta p{font-size:13.5px}
  .tabela-root .dark-cta-actions{flex-direction:column;width:100%;align-items:stretch}
  .tabela-root .dark-cta-actions .t-btn{width:100%;justify-content:center}

  /* Fork */
  .tabela-root .fork-card{padding:22px;gap:14px;border-radius:var(--r)}
  .tabela-root .fork-card h3{font-size:20px}
  .tabela-root .fork-row{padding:12px 14px}
  .tabela-root .fork-row .name{font-size:13.5px}
  .tabela-root .fork-row .desc{font-size:11.5px}
  .tabela-root .fork-row .price{font-size:15px}
  .tabela-root .fork-head svg{width:30px;height:30px}

  /* Pacotes */
  .tabela-root .pack{padding:24px 20px;gap:16px;border-radius:var(--r-lg)}
  .tabela-root .pack-popular{transform:none;box-shadow:0 0 0 2px var(--rose-1),var(--shadow-soft)}
  .tabela-root .pack-popular:hover{transform:translateY(-2px)}
  .tabela-root .pack h3{font-size:22px}
  .tabela-root .pack-price .v{font-size:34px}
  .tabela-root .pack-features{padding-top:16px;gap:8px}
  .tabela-root .pack-features li{font-size:12.5px;gap:8px}
  .tabela-root .pack-features li svg{width:14px;height:14px}
  .tabela-root .pack-meta .row .lbl,.tabela-root .pack-meta .row .val{font-size:11px}

  /* Matrix horizontal scroll */
  .tabela-root .matrix{margin-top:24px;overflow-x:auto;-webkit-overflow-scrolling:touch}
  .tabela-root .matrix table{min-width:560px}
  .tabela-root .matrix th,.tabela-root .matrix td{padding:10px 12px;font-size:12px}
  .tabela-root .matrix tr.row-price td{padding:12px;font-size:18px}
  .tabela-root .matrix-toggle .t-btn{font-size:12px}

  /* Ativos: 1 col */
  .tabela-root .assets-grid{grid-template-columns:1fr}
  .tabela-root .asset{padding:16px;border-radius:var(--r-sm)}
  .tabela-root .asset h4{font-size:15px}
  .tabela-root .asset .desc{font-size:12px}
  .tabela-root .asset::after{display:none}

  /* Articles */
  .tabela-root .articles{grid-template-columns:1fr}
  .tabela-root .article-pack{padding:18px;flex-direction:row;justify-content:space-between;align-items:center;text-align:left}
  .tabela-root .article-pack .qty{font-size:13.5px}
  .tabela-root .article-pack .price{font-size:24px;margin-top:0}
  .tabela-root .article-pack .unit{font-size:9.5px;margin-top:0}

  /* Iscas */
  .tabela-root .iscas-grid{grid-template-columns:1fr}
  .tabela-root .iscas-cat{margin-bottom:28px}
  .tabela-root .iscas-cat-head{flex-direction:row;align-items:center;gap:8px;flex-wrap:wrap}
  .tabela-root .iscas-cat-head h3{font-size:16px}
  .tabela-root .iscas-cat-head .sub{font-size:9px}
  .tabela-root .isca{padding:14px}
  .tabela-root .isca h4{font-size:13.5px}

  /* Funis */
  .tabela-root .funis{grid-template-columns:1fr}
  .tabela-root .funil{padding:22px;gap:10px;border-radius:var(--r)}
  .tabela-root .funil h3{font-size:20px}
  .tabela-root .funil .price{font-size:26px}
  .tabela-root .funil-flow{display:none}
  .tabela-root .funil-svg{margin-top:10px;padding-top:10px}
  .tabela-root .funil-svg svg{max-height:80px}

  /* Comunidade */
  .tabela-root .community{padding:28px 22px;gap:20px;border-radius:var(--r-lg)}
  .tabela-root .community-left h2{font-size:26px}
  .tabela-root .community-left p{font-size:13.5px}
  .tabela-root .community-price{font-size:36px}

  /* Rules */
  .tabela-root .rules{padding:32px 22px;border-radius:var(--r-lg)}
  .tabela-root .rules h2{font-size:22px;margin-bottom:18px}
  .tabela-root .rules-grid{gap:8px}
  .tabela-root .rules-grid li{font-size:12.5px;padding:4px 0;gap:10px}

  /* Ops */
  .tabela-root .ops{grid-template-columns:1fr;gap:10px}
  .tabela-root .op-card{padding:20px}
  .tabela-root .op-card h4{font-size:16px}
  .tabela-root .op-card p{font-size:12.5px}

  /* Notdo */
  .tabela-root .notdo{padding:18px 20px}
  .tabela-root .notdo li{font-size:12.5px}

  /* Calculadora */
  .tabela-root .calc{padding:20px;gap:18px;border-radius:var(--r-lg)}
  .tabela-root .calc-section{margin-bottom:18px}
  .tabela-root .calc-options{gap:6px}
  .tabela-root .calc-opt{padding:8px 12px;font-size:12px;min-height:36px}
  .tabela-root .calc-opt-price{font-size:10.5px}
  .tabela-root .calc-right{padding:22px;border-radius:var(--r)}
  .tabela-root .calc-total{font-size:34px}
  .tabela-root .calc-section .lbl{font-size:9.5px}
  .tabela-root .calc-summary-row{font-size:12px}

  /* FAQ */
  .tabela-root .faq-q{padding:16px 18px;font-size:14px;gap:12px}
  .tabela-root .faq-a{padding:0 18px;font-size:13px}
  .tabela-root .faq-item.open .faq-a{padding-bottom:18px;max-height:520px}

  /* Final CTA */
  .tabela-root .final-cta{padding:40px 22px;border-radius:var(--r-lg)}
  .tabela-root .final-cta h2{font-size:24px}
  .tabela-root .final-cta p{font-size:13.5px}
  .tabela-root .final-cta-actions{flex-direction:column;width:100%;align-items:stretch}
  .tabela-root .final-cta-actions .t-btn{width:100%;justify-content:center}

  /* Foot */
  .tabela-root .foot{font-size:9px;padding:24px 0 32px}
  .tabela-root .foot .sep{margin:0 6px}

  /* Touch targets mínimos 44px */
  .tabela-root .t-btn{min-height:44px}
  .tabela-root .topnav-cta{min-height:36px}
  .tabela-root .calc-opt{min-height:40px}
  .tabela-root .faq-q{min-height:54px}
}

/* iPhone SE / 375px / extra small */
@media (max-width:380px){
  .tabela-root .t-shell,.tabela-root .t-shell-narrow{padding:0 14px}
  .tabela-root .hero-stats .num{font-size:20px}
  .tabela-root .pack-price .v{font-size:30px}
  .tabela-root .community-price{font-size:32px}
  .tabela-root .calc-total{font-size:30px}
}
`
